export default {
   defaultForm: {
      gender: '',
      age: '',
      genres: [],
      feelings: [],
      typeOfHoliday: '',
      season: ''
   },
   showAbout: false,
   activeLocation: null,
   form: {
      gender: '',
      age: '',
      genres: [],
      feelings: [],
      typeOfHoliday: '',
      season: ''
   },
   formResults: [],
   topThree: [],
   resultsFound: false,
   topPerGenre: [],
   genres: [
      'Biography',
      'Documentary',
      'Horror',
      'Action',
      'Drama',
      'Comedy',
      'Crime',
      'Adventure',
      'Sci-Fi',
      'Thriller',
      'Mystery',
      'Romance',
      'Fantasy',
      'Music',
      'Western',
      'History',
   ],
   feelings: {
      happy: [
         'Absurd',
         'Campy',
         'Charming',
         'Deadpan',
         'Heartfelt',
         'Intimate',
         'Irreverent',
         'Quirky',
         'Raunchy',
         'Romantic',
         'Scandalous',
         'Sentimental',
         'Witty',
      ],
      emotional: [
         'Chilling',
         'Emotional',
         'Intimate',
         'Scandalous',
         'Sentimental',
         'Sad',
      ],
      scared: [
         'Chilling',
         'Dark',
         'Emotional',
         'Exciting',
         'Gritty',
         'Heartfelt',
         'Irreverent',
         'Mind-bending',
         'Offbeat',
         'Omnious',
         'Provocative',
         'Scandelous',
         'Scary',
         'Suspenseful',
         'Violent',
      ],
      apprehensive: [
         'Chilling',
         'Dark',
         'Investigative',
         'Offbeat',
         'Omnious',
         'Scandelous',
         'Scary',
         'Suspenseful',
         'Violent',
         'Tense',
         'Nervous',
         'Jumpy',
         'Uneasy',
         'Anxious',
      ],
      inspired: [
         'Feel-Good',
         'Inspiring',
         'Influenced',
         'Motivated',
         'Encouraged',
         'Stimulate',
      ]
   },
   database: [
      {
        "cityOrCountry": "Tokyo",
        "country": "Japan",
        "seasonRating": {
           "spring": 23,
           "summer": 31,
           "fall": 17,
           "winter": 10
        },
        "monthsToVisit": [
           "March",
           "April",





        ],
        "season": [
           "Spring",


        ],
        "show": "Alice in Borderland",
        "typeOfShow": "Series",
        "rating": 7.6,
        "genre": [
           "Action",
           "Sci-Fi",
           "Mystery"
        ],
        "feeling": [
           "Dark",
           "Suspenseful",

        ],
        "typeOfHoliday": [
           "Adventure Holiday",
           "City Break"
        ],
        "visitType": "Town",
        "activities": "81",
        "hotels": 22,
        "restaurants": "101,418",
        "topRestaurants": "Gyopao Gyoza Roppongi",
        "placeToVisit": "Shibuya Crossing",
        "male": {
           "under18": "75",
           "18-29": 81,
           "30-44": 77,
           "45Plus": 75
        },
        "female": {
           "under18": "77",
           "18-29": 71,
           "30-44": 78,
           "45Plus": 77
        },
        "other": {
           "under18": "76",
           "18-29": 76,
           "30-44": 77.5,
           "45Plus": 76
        }
     },
      {
        "cityOrCountry": "San Francisco",
        "country": "California, USA",
        "seasonRating": {
           "spring": 18,
           "summer": 20,
           "fall": 18,
           "winter": 14
        },
        "monthsToVisit": [
           "September",
           "October",
           "November",




        ],
        "season": [
           "Winter",


        ],
        "show": "Always Be My Maybe",
        "typeOfShow": "Movie",
        "rating": 6.8,
        "genre": [
           "Comedy",
           "Romance",

        ],
        "feeling": [
           "Witty",
           "Irreverent",
           "Romantic"
        ],
        "typeOfHoliday": [
           "City Break",
           "Couples Holiday"
        ],
        "visitType": "City",
        "activities": "114",
        "hotels": 10,
        "restaurants": "4,922",
        "topRestaurants": "Mersea Restaurant & Bar",
        "placeToVisit": "",
        "male": {
           "under18": "67",
           "18-29": 70,
           "30-44": 67,
           "45Plus": 67
        },
        "female": {
           "under18": "68",
           "18-29": 51,
           "30-44": 67,
           "45Plus": 68
        },
        "other": {
           "under18": "67.5",
           "18-29": 60.5,
           "30-44": 67,
           "45Plus": 67.5
        }
     },
      {
        "cityOrCountry": "Frederick",
        "country": "Colorado, USA",
        "seasonRating": {
           "spring": 22,
           "summer": 32,
           "fall": 11,
           "winter": 6
        },
        "monthsToVisit": [
           "August",






        ],
        "season": [
           "Summer",


        ],
        "show": "American Murder: The Family Next Door",
        "typeOfShow": "Documentary",
        "rating": 7.2,
        "genre": [
           "Documentary",
           "Crime",

        ],
        "feeling": [
           "Ominous",
           "Investigative",
           "Emotional"
        ],
        "typeOfHoliday": [
           "City Break",
           "Adventure Holiday"
        ],
        "visitType": "State",
        "activities": "0",
        "hotels": 3,
        "restaurants": "81",
        "topRestaurants": "Georgia Boys BBQ Smokehouse",
        "placeToVisit": "",
        "male": {
           "under18": "71",
           "18-29": 66,
           "30-44": 71,
           "45Plus": 71
        },
        "female": {
           "under18": "73",
           "18-29": 69,
           "30-44": 73,
           "45Plus": 73
        },
        "other": {
           "under18": "72",
           "18-29": 67.5,
           "30-44": 72,
           "45Plus": 72
        }
     },
      {
        "cityOrCountry": "Oceanside",
        "country": "California, USA",
        "seasonRating": {
           "spring": 19,
           "summer": 23,
           "fall": 20,
           "winter": 17
        },
        "monthsToVisit": [
           "June",
           "July",
           "August",
           "September",
           "October",


        ],
        "season": [
           "Summer",
           "Autumn",

        ],
        "show": "American Vandal",
        "typeOfShow": "Series",
        "rating": 8.2,
        "genre": [
           "Comedy",
           "Crime",
           "Mystery"
        ],
        "feeling": [
           "Deadpan",
           "Raunchy",
           "Irreverent"
        ],
        "typeOfHoliday": [
           "Beach Holiday",
           "Remote"
        ],
        "visitType": "Town",
        "activities": "55",
        "hotels": 5,
        "restaurants": "3,774",
        "topRestaurants": "Mucca Osteria",
        "placeToVisit": "",
        "male": {
           "under18": "81",
           "18-29": 83,
           "30-44": 84,
           "45Plus": 81
        },
        "female": {
           "under18": "80",
           "18-29": 50,
           "30-44": 82,
           "45Plus": 79
        },
        "other": {
           "under18": "80.5",
           "18-29": 66.5,
           "30-44": 83,
           "45Plus": 80
        }
     },
      {
        "cityOrCountry": "Santa Clarita",
        "country": "California, USA",
        "seasonRating": {
           "spring": 26,
           "summer": 35,
           "fall": 28,
           "winter": 18
        },
        "monthsToVisit": [
           "September",
           "October",
           "November",
           "December",



        ],
        "season": [
           "Winter",


        ],
        "show": "Atypical",
        "typeOfShow": "Series",
        "rating": 8.3,
        "genre": [
           "Comedy",
           "Drama",

        ],
        "feeling": [
           "Quirky",
           "Heartfelt",
           "Inspiring"
        ],
        "typeOfHoliday": [
           "City Break",
           "Adventure Holiday"
        ],
        "visitType": "Town",
        "activities": "389",
        "hotels": 3,
        "restaurants": "461",
        "topRestaurants": "Egg Plantation",
        "placeToVisit": "aquarium of the pacific",
        "male": {
           "under18": "82",
           "18-29": 82,
           "30-44": 82,
           "45Plus": 82
        },
        "female": {
           "under18": "84",
           "18-29": 77,
           "30-44": 83,
           "45Plus": 84
        },
        "other": {
           "under18": "83",
           "18-29": 79.5,
           "30-44": 82.5,
           "45Plus": 83
        }
     },
      {
        "cityOrCountry": "London",
        "country": "England, UK",
        "seasonRating": {
           "spring": 18,
           "summer": 23,
           "fall": 16,
           "winter": 9
        },
        "monthsToVisit": [
           "March",
           "April",
           "May",




        ],
        "season": [
           "Spring",


        ],
        "show": "Behind Her Eyes",
        "typeOfShow": "Series",
        "rating": 7.2,
        "genre": [
           "Fantasy",
           "Mystery",
           "Thriller"
        ],
        "feeling": [
           "Mind-bending",
           "Suspenseful",

        ],
        "typeOfHoliday": [
           "Couples Holiday",
           "City Break"
        ],
        "visitType": "City",
        "activities": "77",
        "hotels": 141,
        "restaurants": "20,375",
        "topRestaurants": "Hibox",
        "placeToVisit": "Clerkenwell Grind",
        "male": {
           "under18": "71",
           "18-29": 75,
           "30-44": 72,
           "45Plus": 71
        },
        "female": {
           "under18": "73",
           "18-29": 86,
           "30-44": 74,
           "45Plus": 73
        },
        "other": {
           "under18": "72",
           "18-29": 80.5,
           "30-44": 73,
           "45Plus": 72
        }
     },
      {
        "cityOrCountry": "Albuquerque",
        "country": "New Mexico, USA",
        "seasonRating": {
           "spring": 27,
           "summer": 32,
           "fall": 29,
           "winter": 15
        },
        "monthsToVisit": [
           "September",
           "October",
           "November",




        ],
        "season": [
           "Winter",


        ],
        "show": "Better Call Saul",
        "typeOfShow": "Series",
        "rating": 8.8,
        "genre": [
           "Crime",
           "Drama",
           "Comedy"
        ],
        "feeling": [
           "Gritty",
           "Suspenseful",
           "Gritty"
        ],
        "typeOfHoliday": [
           "City Break",
           "Adventure Holiday"
        ],
        "visitType": "State",
        "activities": "69",
        "hotels": 5,
        "restaurants": "1,517",
        "topRestaurants": "Antiquity Restaurant",
        "placeToVisit": "Los Pollos Hermanos (AKA Twisters) 4257 Isleta Boulevard Southwest, Albuquerque",
        "male": {
           "under18": "88",
           "18-29": 93,
           "30-44": 89,
           "45Plus": 87
        },
        "female": {
           "under18": "85",
           "18-29": 79,
           "30-44": 86,
           "45Plus": 85
        },
        "other": {
           "under18": "86.5",
           "18-29": 86,
           "30-44": 87.5,
           "45Plus": 86
        }
     },
      {
        "cityOrCountry": "California",
        "country": "California, USA",
        "seasonRating": {
           "spring": 16,
           "summer": 27,
           "fall": 24,
           "winter": 4
        },
        "monthsToVisit": [
           "April",






        ],
        "season": [
           "Spring",


        ],
        "show": "Bird Box",
        "typeOfShow": "Movie",
        "rating": 6.6,
        "genre": [
           "Horror",
           "Sci-Fi",
           "Thriller"
        ],
        "feeling": [
           "Chilling",
           "Scary",
           "Suspenseful"
        ],
        "typeOfHoliday": [
           "Couples Holiday",
           "Beach Holiday"
        ],
        "visitType": "City",
        "activities": "389",
        "hotels": 3,
        "restaurants": "461",
        "topRestaurants": "Egg Plantation",
        "placeToVisit": "Smith River",
        "male": {
           "under18": "65",
           "18-29": 63,
           "30-44": 65,
           "45Plus": 65
        },
        "female": {
           "under18": "69",
           "18-29": 65,
           "30-44": 70,
           "45Plus": 69
        },
        "other": {
           "under18": "67",
           "18-29": 64,
           "30-44": 67.5,
           "45Plus": 67
        }
     },
      {
        "cityOrCountry": "Albuquerque",
        "country": "New Mexico, USA",
        "seasonRating": {
           "spring": 27,
           "summer": 32,
           "fall": 29,
           "winter": 15
        },
        "monthsToVisit": [
           "September",
           "October",
           "November",




        ],
        "season": [
           "Winter",


        ],
        "show": "Breaking Bad",
        "typeOfShow": "Series",
        "rating": 9.4,
        "genre": [
           "Crime",
           "Drama",
           "Thriller"
        ],
        "feeling": [
           "Violent",
           "Gritty",
           "Dark"
        ],
        "typeOfHoliday": [
           "City Break",
           "Adventure Holiday"
        ],
        "visitType": "State",
        "activities": "69",
        "hotels": 5,
        "restaurants": "1,517",
        "topRestaurants": "Antiquity Restaurant",
        "placeToVisit": "Rio Rancho High School",
        "male": {
           "under18": "95",
           "18-29": 97,
           "30-44": 96,
           "45Plus": 95
        },
        "female": {
           "under18": "92",
           "18-29": 83,
           "30-44": 92,
           "45Plus": 91
        },
        "other": {
           "under18": "93.5",
           "18-29": 90,
           "30-44": 94,
           "45Plus": 93
        }
     },
      {
        "cityOrCountry": "Bath",
        "country": "England, UK",
        "seasonRating": {
           "spring": 17,
           "summer": 21,
           "fall": 11,
           "winter": 8
        },
        "monthsToVisit": [
           "June",
           "July",
           "August",
           "September",



        ],
        "season": [
           "Summer",
           "Autumn",

        ],
        "show": "Bridgerton",
        "typeOfShow": "Series",
        "rating": 7.3,
        "genre": [
           "Drama",
           "Romance",
           "History"
        ],
        "feeling": [
           "Witty",
           "Emotional",
           "Romantic"
        ],
        "typeOfHoliday": [
           "Couples Holiday",
           "Remote"
        ],
        "visitType": "Country Side",
        "activities": "16",
        "hotels": 56,
        "restaurants": "417",
        "topRestaurants": "Menu Gordon Jones",
        "placeToVisit": "The Historic Dockyard Chatham",
        "male": {
           "under18": "62",
           "18-29": 81,
           "30-44": 66,
           "45Plus": 61
        },
        "female": {
           "under18": "77",
           "18-29": 70,
           "30-44": 76,
           "45Plus": 77
        },
        "other": {
           "under18": "69.5",
           "18-29": 75.5,
           "30-44": 71,
           "45Plus": 69
        }
     },
      {
        "cityOrCountry": "Melbourne",
        "country": "Australia",
        "seasonRating": {
           "spring": 20,
           "summer": 27,
           "fall": 17,
           "winter": 14
        },
        "monthsToVisit": [
           "March",
           "April",
           "May",




        ],
        "season": [
           "Spring",


        ],
        "show": "Clickbait",
        "typeOfShow": "Series",
        "rating": 7.2,
        "genre": [
           "Crime",
           "Thriller",
           "Mystery"
        ],
        "feeling": [
           "Suspenful",
           "Emotional",
           "Exciting"
        ],
        "typeOfHoliday": [
           "City Break",
           "Adventure Holiday"
        ],
        "visitType": "City",
        "activities": "130",
        "hotels": 26,
        "restaurants": "4,341",
        "topRestaurants": "Foglia di Fico",
        "placeToVisit": "Oakland Bay Bridge",
        "male": {
           "under18": "71",
           "18-29": 74,
           "30-44": 71,
           "45Plus": 71
        },
        "female": {
           "under18": "74",
           "18-29": 58,
           "30-44": 73,
           "45Plus": 73
        },
        "other": {
           "under18": "72.5",
           "18-29": 66,
           "30-44": 72,
           "45Plus": 72
        }
     },
      {
        "cityOrCountry": "Los Angeles",
        "country": "California, USA",
        "seasonRating": {
           "spring": 24,
           "summer": 29,
           "fall": 23,
           "winter": 21
        },
        "monthsToVisit": [
           "March",
           "April",
           "May",




        ],
        "season": [
           "Spring",


        ],
        "show": "Cobra Kai",
        "typeOfShow": "Series",
        "rating": 8.6,
        "genre": [
           "Action",
           "Comedy",
           "Drama"
        ],
        "feeling": [
           "Heartfelt",
           "Feel-Good",
           "Exciting"
        ],
        "typeOfHoliday": [
           "Couples Holiday",
           "Beach Holiday"
        ],
        "visitType": "City",
        "activities": "50",
        "hotels": 3,
        "restaurants": "13,365",
        "topRestaurants": "n,naka",
        "placeToVisit": "",
        "male": {
           "under18": "86",
           "18-29": 87,
           "30-44": 86,
           "45Plus": 86
        },
        "female": {
           "under18": "85",
           "18-29": 64,
           "30-44": 84,
           "45Plus": 85
        },
        "other": {
           "under18": "85.5",
           "18-29": 75.5,
           "30-44": 85,
           "45Plus": 85.5
        }
     },
      {
        "cityOrCountry": "Los Angeles",
        "country": "California, USA",
        "seasonRating": {
           "spring": 24,
           "summer": 29,
           "fall": 23,
           "winter": 21
        },
        "monthsToVisit": [
           "March",
           "April",
           "May",




        ],
        "season": [
           "Spring",


        ],
        "show": "Community",
        "typeOfShow": "Series",
        "rating": 8.5,
        "genre": [
           "Comedy",
           "Drama",

        ],
        "feeling": [
           "Witty",
           "Irreverent",

        ],
        "typeOfHoliday": [
           "Adventure Holiday",
           "Beach Holiday"
        ],
        "visitType": "City",
        "activities": "50",
        "hotels": 3,
        "restaurants": "13,365",
        "topRestaurants": "n,naka",
        "placeToVisit": "",
        "male": {
           "under18": "85",
           "18-29": 88,
           "30-44": 87,
           "45Plus": 85
        },
        "female": {
           "under18": "83",
           "18-29": 83,
           "30-44": 84,
           "45Plus": 83
        },
        "other": {
           "under18": "84",
           "18-29": 85.5,
           "30-44": 85.5,
           "45Plus": 84
        }
     },
      {
        "cityOrCountry": "New York City",
        "country": "New York, USA",
        "seasonRating": {
           "spring": 22,
           "summer": 29,
           "fall": 18,
           "winter": 4
        },
        "monthsToVisit": [
           "April",
           "June",





        ],
        "season": [
           "Summer",


        ],
        "show": "Daredevil",
        "typeOfShow": "Series",
        "rating": 8.6,
        "genre": [
           "Action",
           "Crime",
           "Sci-Fi"
        ],
        "feeling": [
           "Gritty",
           "Dark",
           "Exciting"
        ],
        "typeOfHoliday": [
           "Adventure Holiday",
           "City Break"
        ],
        "visitType": "City",
        "activities": "127",
        "hotels": 40,
        "restaurants": "11,406",
        "topRestaurants": "Club A Steakhouse",
        "placeToVisit": "",
        "male": {
           "under18": "86",
           "18-29": 90,
           "30-44": 88,
           "45Plus": 85
        },
        "female": {
           "under18": "84",
           "18-29": 69,
           "30-44": 86,
           "45Plus": 83
        },
        "other": {
           "under18": "85",
           "18-29": 79.5,
           "30-44": 87,
           "45Plus": 84
        }
     },
      {
        "cityOrCountry": "Mexico City",
        "country": "Mexico",
        "seasonRating": {
           "spring": 27,
           "summer": 25,
           "fall": 23,
           "winter": 22
        },
        "monthsToVisit": [
           "December",
           "January",
           "February",
           "March",
           "April",


        ],
        "season": [
           "Winter",
           "Spring",

        ],
        "show": "Daughter from Another Mother",
        "typeOfShow": "Series",
        "rating": 7.4,
        "genre": [
           "Comedy",
           "Drama",
           "Adventure"
        ],
        "feeling": [
           "Witty",
           "Heartfelt",

        ],
        "typeOfHoliday": [
           "City Break",
           "Adventure Holiday"
        ],
        "visitType": "City",
        "activities": "62",
        "hotels": 13,
        "restaurants": "6,487",
        "topRestaurants": "Parrilla Urbana Division del Norte",
        "placeToVisit": "",
        "male": {
           "under18": "-",
           "18-29": 74,
           "30-44": 68,
           "45Plus": 70
        },
        "female": {
           "under18": "-",
           "18-29": 78,
           "30-44": 75,
           "45Plus": 71
        },
        "other": {
           "under18": "-",
           "18-29": 76,
           "30-44": 71.5,
           "45Plus": 70.5
        }
     },
      {
        "cityOrCountry": "Laguna Beach",
        "country": "California, USA",
        "seasonRating": {
           "spring": 23,
           "summer": 27,
           "fall": 22,
           "winter": 20
        },
        "monthsToVisit": [
           "April",
           "May",





        ],
        "season": [
           "Summer",


        ],
        "show": "Dead To Me",
        "typeOfShow": "Series",
        "rating": 8,
        "genre": [
           "Comedy",
           "Crime",
           "Drama"
        ],
        "feeling": [
           "Witty",
           "Intimate",
           "Emotional"
        ],
        "typeOfHoliday": [
           "Couples Holiday",
           "Beach Holiday"
        ],
        "visitType": "State",
        "activities": "30",
        "hotels": 1,
        "restaurants": "112",
        "topRestaurants": "Nick's Laguna Beach",
        "placeToVisit": "Malibu Farm Restaurant in Malibu Pier (whcih is \"the Coretta Cafe\")",
        "male": {
           "under18": "79",
           "18-29": 80,
           "30-44": 80,
           "45Plus": 78
        },
        "female": {
           "under18": "81",
           "18-29": 76,
           "30-44": 80,
           "45Plus": 80
        },
        "other": {
           "under18": "80",
           "18-29": 78,
           "30-44": 80,
           "45Plus": 79
        }
     },
      {
        "cityOrCountry": "Boston",
        "country": "Massachusetts, USA",
        "seasonRating": {
           "spring": 19,
           "summer": 28,
           "fall": 17,
           "winter": 3
        },
        "monthsToVisit": [
           "June",
           "July",
           "August",
           "September",
           "October",


        ],
        "season": [
           "Summer",
           "Autumn",

        ],
        "show": "DON'T LOOK UP",
        "typeOfShow": "Movie",
        "rating": 7.3,
        "genre": [
           "Comedy",
           "Drama",
           "Sci-Fi"
        ],
        "feeling": [
           "Quirky",
           "Witty",

        ],
        "typeOfHoliday": [
           "City Break",
           "Adventure Holiday"
        ],
        "visitType": "State",
        "activities": "5",
        "hotels": 241,
        "restaurants": "2466",
        "topRestaurants": "Mario's Resturant",
        "placeToVisit": "Museum of Fine Arts boston",
        "male": {
           "under18": "76",
           "18-29": 72,
           "30-44": 72,
           "45Plus": 72
        },
        "female": {
           "under18": "72",
           "18-29": 73,
           "30-44": 74,
           "45Plus": 75
        },
        "other": {
           "under18": "74",
           "18-29": 72.5,
           "30-44": 73,
           "45Plus": 73.5
        }
     },
      {
        "cityOrCountry": "Albuquerque",
        "country": "New Mexico, USA",
        "seasonRating": {
           "spring": 27,
           "summer": 32,
           "fall": 29,
           "winter": 15
        },
        "monthsToVisit": [
           "September",
           "October",
           "November",




        ],
        "season": [
           "Winter",


        ],
        "show": "El Camino: A Breaking Bad Movie",
        "typeOfShow": "Movie",
        "rating": 7.3,
        "genre": [
           "Action",
           "Crime",
           "Western"
        ],
        "feeling": [
           "Gritty",
           "Dark",
           "Violent"
        ],
        "typeOfHoliday": [
           "City Break",
           "Adventure Holiday"
        ],
        "visitType": "City",
        "activities": "112",
        "hotels": 1,
        "restaurants": "1,517",
        "topRestaurants": "Antiquity Restaurant",
        "placeToVisit": "501 11th Street NW, Albuquerque, New Mexico",
        "male": {
           "under18": "73",
           "18-29": 77,
           "30-44": 75,
           "45Plus": 72
        },
        "female": {
           "under18": "72",
           "18-29": 71,
           "30-44": 74,
           "45Plus": 71
        },
        "other": {
           "under18": "72.5",
           "18-29": 74,
           "30-44": 74.5,
           "45Plus": 71.5
        }
     },
      {
        "cityOrCountry": "Madrid",
        "country": "Spain",
        "seasonRating": {
           "spring": 22,
           "summer": 32,
           "fall": 19,
           "winter": 12
        },
        "monthsToVisit": [
           "September",
           "October",
           "November",




        ],
        "season": [
           "Winter",


        ],
        "show": "Elite",
        "typeOfShow": "Series",
        "rating": 7.4,
        "genre": [
           "Crime",
           "Mystery",
           "Thriller"
        ],
        "feeling": [
           "Suspenseful",
           "Steamy",

        ],
        "typeOfHoliday": [
           "Adventure Holiday",
           "City Break"
        ],
        "visitType": "City",
        "activities": "90",
        "hotels": 13,
        "restaurants": "11,818",
        "topRestaurants": "Los Montes de Galicia",
        "placeToVisit": "",
        "male": {
           "under18": "74",
           "18-29": 69,
           "30-44": 75,
           "45Plus": 74
        },
        "female": {
           "under18": "76",
           "18-29": 57,
           "30-44": 77,
           "45Plus": 75
        },
        "other": {
           "under18": "75",
           "18-29": 63,
           "30-44": 76,
           "45Plus": 74.5
        }
     },
      {
        "cityOrCountry": "Paris",
        "country": "France",
        "seasonRating": {
           "spring": 20,
           "summer": 25,
           "fall": 16,
           "winter": 8
        },
        "monthsToVisit": [
           "June",
           "July",
           "August",




        ],
        "season": [
           "Summer",


        ],
        "show": "Emily in Paris",
        "typeOfShow": "Series",
        "rating": 7,
        "genre": [
           "Comedy",
           "Drama",
           "Romance"
        ],
        "feeling": [
           "Feel-Good",
           "Quirky",
           "Romantic"
        ],
        "typeOfHoliday": [
           "City Break",
           "Couples Holiday"
        ],
        "visitType": "City",
        "activities": "48",
        "hotels": 79,
        "restaurants": "17,503",
        "topRestaurants": "Il Etait Un Square",
        "placeToVisit": "Place de Valois",
        "male": {
           "under18": "68",
           "18-29": 70,
           "30-44": 69,
           "45Plus": 68
        },
        "female": {
           "under18": "70",
           "18-29": 54,
           "30-44": 70,
           "45Plus": 70
        },
        "other": {
           "under18": "69",
           "18-29": 62,
           "30-44": 69.5,
           "45Plus": 69
        }
     },
      {
        "cityOrCountry": "Dhaka",
        "country": "Bangladesh",
        "seasonRating": {
           "spring": 32,
           "summer": 33,
           "fall": 29,
           "winter": 25
        },
        "monthsToVisit": [
           "March",
           "April",
           "May",




        ],
        "season": [
           "Spring",


        ],
        "show": "Extraction",
        "typeOfShow": "Movie",
        "rating": 6.7,
        "genre": [
           "Action",
           "Thriller",
           "Mystery"
        ],
        "feeling": [
           "Violent",
           "Exciting",
           "Gritty"
        ],
        "typeOfHoliday": [
           "City Break",
           "Adventure Holiday"
        ],
        "visitType": "City",
        "activities": "28",
        "hotels": 19,
        "restaurants": "787",
        "topRestaurants": "Seasonal Tastes",
        "placeToVisit": "",
        "male": {
           "under18": "67",
           "18-29": 69,
           "30-44": 67,
           "45Plus": 67
        },
        "female": {
           "under18": "66",
           "18-29": 57,
           "30-44": 66,
           "45Plus": 66
        },
        "other": {
           "under18": "66.5",
           "18-29": 63,
           "30-44": 66.5,
           "45Plus": 66.5
        }
     },
      {
        "cityOrCountry": "County Wicklow",
        "country": "Ireland",
        "seasonRating": {
           "spring": 12,
           "summer": 16,
           "fall": 10,
           "winter": 5
        },
        "monthsToVisit": [
           "June",
           "July",
           "August",




        ],
        "season": [
           "Summer",


        ],
        "show": "Fate: The Winx Saga",
        "typeOfShow": "Series",
        "rating": 6.9,
        "genre": [
           "Action",
           "Adventure",
           "Drama"
        ],
        "feeling": [
           "Emotional",
           "Intimate",
           "Exciting"
        ],
        "typeOfHoliday": [
           "Remote",
           "Adventure Holiday"
        ],
        "visitType": "County ",
        "activities": "180",
        "hotels": 52,
        "restaurants": "292",
        "topRestaurants": "The Old Ship",
        "placeToVisit": "Killruddery House",
        "male": {
           "under18": "67",
           "18-29": 71,
           "30-44": 68,
           "45Plus": 66
        },
        "female": {
           "under18": "70",
           "18-29": 65,
           "30-44": 69,
           "45Plus": 69
        },
        "other": {
           "under18": "68.5",
           "18-29": 68,
           "30-44": 68.5,
           "45Plus": 67.5
        }
     },
      {
        "cityOrCountry": "Boston",
        "country": "Massachusetts, USA",
        "seasonRating": {
           "spring": 19,
           "summer": 28,
           "fall": 17,
           "winter": 3
        },
        "monthsToVisit": [
           "June",
           "July",
           "August",
           "September",
           "October",


        ],
        "season": [
           "Summer",
           "Autumn",

        ],
        "show": "Fatherhood",
        "typeOfShow": "Movie",
        "rating": 6.6,
        "genre": [
           "Comedy",
           "Drama",

        ],
        "feeling": [
           "Heartfelt",
           "Feel-Good",
           "Emotional"
        ],
        "typeOfHoliday": [
           "City Break",
           "Adventure Holiday"
        ],
        "visitType": "City",
        "activities": "5",
        "hotels": 13,
        "restaurants": "2,463",
        "topRestaurants": "Mario's Restaurant",
        "placeToVisit": "Boston Common Park",
        "male": {
           "under18": "65",
           "18-29": 74,
           "30-44": 66,
           "45Plus": 65
        },
        "female": {
           "under18": "68",
           "18-29": 58,
           "30-44": 69,
           "45Plus": 67
        },
        "other": {
           "under18": "66.5",
           "18-29": 66,
           "30-44": 67.5,
           "45Plus": 66
        }
     },
      {
        "cityOrCountry": "Atlanta",
        "country": "Georgia, USA",
        "seasonRating": {
           "spring": 27,
           "summer": 31,
           "fall": 28,
           "winter": 18
        },
        "monthsToVisit": [
           "March",
           "April",
           "May",




        ],
        "season": [
           "Spring",


        ],
        "show": "Fear Street Part Three: 1666",
        "typeOfShow": "Movie",
        "rating": 6.6,
        "genre": [
           "Horror",
           "Mystery",

        ],
        "feeling": [
           "Chilling",
           "Scary",
           "Dark"
        ],
        "typeOfHoliday": [
           "Adventure Holiday",
           "City Break"
        ],
        "visitType": "City",
        "activities": "9",
        "hotels": 293,
        "restaurants": "3397",
        "topRestaurants": "Aviva by Kameel",
        "placeToVisit": "Hard Labor Creek State Park",
        "male": {
           "under18": "72",
           "18-29": 66,
           "30-44": 65,
           "45Plus": 65
        },
        "female": {
           "under18": "69",
           "18-29": 69,
           "30-44": 68,
           "45Plus": 68
        },
        "other": {
           "under18": "70.5",
           "18-29": 67.5,
           "30-44": 66.5,
           "45Plus": 66.5
        }
     },
      {
        "cityOrCountry": "Seattle",
        "country": "Washington, USA",
        "seasonRating": {
           "spring": 17,
           "summer": 22,
           "fall": 15,
           "winter": 8
        },
        "monthsToVisit": [
           "September",
           "October",





        ],
        "season": [
           "Winter",


        ],
        "show": "Firefly Lane",
        "typeOfShow": "Series",
        "rating": 7.4,
        "genre": [
           "Drama",
           "Romance",
           "Comedy"
        ],
        "feeling": [
           "Sentimental",
           "Intimate",
           "Heartfelt"
        ],
        "typeOfHoliday": [
           "City Break",
           "Adventure Holiday"
        ],
        "visitType": "State",
        "activities": "56",
        "hotels": 5,
        "restaurants": "3,449",
        "topRestaurants": "Pizzeria Credo",
        "placeToVisit": "CF Pacific Centre in downtown Vancouver",
        "male": {
           "under18": "69",
           "18-29": 77,
           "30-44": 72,
           "45Plus": 68
        },
        "female": {
           "under18": "76",
           "18-29": 72,
           "30-44": 75,
           "45Plus": 75
        },
        "other": {
           "under18": "72.5",
           "18-29": 74.5,
           "30-44": 73.5,
           "45Plus": 71.5
        }
     },
      {
        "cityOrCountry": "Exuma",
        "country": "The Bahamas, Caribbean",
        "seasonRating": {
           "spring": 22,
           "summer": 33,
           "fall": 25,
           "winter": 18
        },
        "monthsToVisit": [
           "March",
           "April",





        ],
        "season": [
           "Spring",


        ],
        "show": "Fyre",
        "typeOfShow": "Documentary",
        "rating": 7.2,
        "genre": [
           "Documentary",
           "Crime",
           "Music"
        ],
        "feeling": [
           "Provocative",
           "Investigative",

        ],
        "typeOfHoliday": [
           "Couples Holiday",
           "Beach Holiday"
        ],
        "visitType": "Island",
        "activities": "64",
        "hotels": 7,
        "restaurants": "58",
        "topRestaurants": "Prime Island Meats and Deli",
        "placeToVisit": "Exuma, The Bahamas",
        "male": {
           "under18": "72",
           "18-29": 76,
           "30-44": 73,
           "45Plus": 72
        },
        "female": {
           "under18": "72",
           "18-29": 77,
           "30-44": 72,
           "45Plus": 72
        },
        "other": {
           "under18": "72",
           "18-29": 76.5,
           "30-44": 72.5,
           "45Plus": 72
        }
     },
      {
        "cityOrCountry": "Cobourg",
        "country": "Ontario, Canada",
        "seasonRating": {
           "spring": 17,
           "summer": 24,
           "fall": 7,
           "winter": -1
        },
        "monthsToVisit": [
           "August",






        ],
        "season": [
           "Summer",


        ],
        "show": "Ginny & Georgia",
        "typeOfShow": "Series",
        "rating": 7.5,
        "genre": [
           "Comedy",
           "Drama",

        ],
        "feeling": [
           "Scandelous",
           "Emotional",
           "Romantic"
        ],
        "typeOfHoliday": [
           "Remote",
           "Beach Holiday"
        ],
        "visitType": "State",
        "activities": "17",
        "hotels": 2,
        "restaurants": "65",
        "topRestaurants": "The Buttermilk Cafe",
        "placeToVisit": "the grand Victoria Hall",
        "male": {
           "under18": "69",
           "18-29": 62,
           "30-44": 70,
           "45Plus": 69
        },
        "female": {
           "under18": "76",
           "18-29": 70,
           "30-44": 76,
           "45Plus": 77
        },
        "other": {
           "under18": "72.5",
           "18-29": 66,
           "30-44": 73,
           "45Plus": 73
        }
     },
      {
        "cityOrCountry": "San Fernando Valley",
        "country": "California, USA",
        "seasonRating": {
           "spring": 25,
           "summer": 33,
           "fall": 23,
           "winter": 20
        },
        "monthsToVisit": [
           "March",
           "April",
           "May",




        ],
        "season": [
           "Spring",


        ],
        "show": "GLOW",
        "typeOfShow": "Series",
        "rating": 6.9,
        "genre": [
           "Comedy",
           "Drama",

        ],
        "feeling": [
           "Witty",
           "Irreverent",

        ],
        "typeOfHoliday": [
           "City Break",
           "Couples Holiday"
        ],
        "visitType": "County",
        "activities": "50",
        "hotels": 3,
        "restaurants": "13,365",
        "topRestaurants": "n,naka",
        "placeToVisit": "Moonlight Rollerway’s",
        "male": {
           "under18": "80",
           "18-29": 75,
           "30-44": 80,
           "45Plus": 80
        },
        "female": {
           "under18": "81",
           "18-29": 70,
           "30-44": 80,
           "45Plus": 81
        },
        "other": {
           "under18": "80.5",
           "18-29": 72.5,
           "30-44": 80,
           "45Plus": 80.5
        }
     },
      {
        "cityOrCountry": "Santa Fe",
        "country": "New Mexico, USA",
        "seasonRating": {
           "spring": 22,
           "summer": 30,
           "fall": 11,
           "winter": 6
        },
        "monthsToVisit": [
           "September",
           "October",
           "November",




        ],
        "season": [
           "Winter",


        ],
        "show": "Godless",
        "typeOfShow": "Series",
        "rating": 8.3,
        "genre": [
           "Action",
           "Drama",
           "Western"
        ],
        "feeling": [
           "Gritty",
           "Dark",

        ],
        "typeOfHoliday": [
           "City Break",
           "Adventure Holiday"
        ],
        "visitType": "Village",
        "activities": "7",
        "hotels": 5,
        "restaurants": "380",
        "topRestaurants": "Sazon",
        "placeToVisit": "santa fe studios",
        "male": {
           "under18": "83",
           "18-29": 85,
           "30-44": 83,
           "45Plus": 82
        },
        "female": {
           "under18": "84",
           "18-29": 65,
           "30-44": 84,
           "45Plus": 83
        },
        "other": {
           "under18": "83.5",
           "18-29": 75,
           "30-44": 83.5,
           "45Plus": 82.5
        }
     },
      {
        "cityOrCountry": "Los Angeles",
        "country": "California, USA",
        "seasonRating": {
           "spring": 24,
           "summer": 29,
           "fall": 23,
           "winter": 21
        },
        "monthsToVisit": [
           "March",
           "April",
           "May",




        ],
        "season": [
           "Spring",


        ],
        "show": "Grace and Frankie",
        "typeOfShow": "Series",
        "rating": 8.2,
        "genre": [
           "Comedy",
           "Drama",

        ],
        "feeling": [
           "Quirky",
           "Witty",
           "Heartfelt"
        ],
        "typeOfHoliday": [
           "Couples Holiday",
           "Beach Holiday"
        ],
        "visitType": "Town",
        "activities": "389",
        "hotels": 3,
        "restaurants": "13,365",
        "topRestaurants": "n,naka",
        "placeToVisit": "",
        "male": {
           "under18": "79",
           "18-29": 83,
           "30-44": 82,
           "45Plus": 79
        },
        "female": {
           "under18": "85",
           "18-29": 68,
           "30-44": 84,
           "45Plus": 84
        },
        "other": {
           "under18": "82",
           "18-29": 75.5,
           "30-44": 83,
           "45Plus": 81.5
        }
     },
      {
        "cityOrCountry": "New York City",
        "country": "New York, USA",
        "seasonRating": {
           "spring": 22,
           "summer": 29,
           "fall": 18,
           "winter": 4
        },
        "monthsToVisit": [
           "April",
           "May",
           "June",




        ],
        "season": [
           "Summer",


        ],
        "show": "Halston",
        "typeOfShow": "Docu-Series",
        "rating": 7.5,
        "genre": [
           "Biography",
           "Drama",

        ],
        "feeling": [
           "Intimate",
           "Inspiring",

        ],
        "typeOfHoliday": [
           "Adventure Holiday",
           "City Break"
        ],
        "visitType": "City",
        "activities": "127",
        "hotels": 40,
        "restaurants": "11,406",
        "topRestaurants": "Club A Steakhouse",
        "placeToVisit": "",
        "male": {
           "under18": "75",
           "18-29": 55,
           "30-44": 74,
           "45Plus": 75
        },
        "female": {
           "under18": "75",
           "18-29": 75,
           "30-44": 75,
           "45Plus": 75
        },
        "other": {
           "under18": "75",
           "18-29": 65,
           "30-44": 74.5,
           "45Plus": 75
        }
     },
      {
        "cityOrCountry": "Baltimore",
        "country": "Maryland, USA",
        "seasonRating": {
           "spring": 25,
           "summer": 31,
           "fall": 14,
           "winter": 5
        },
        "monthsToVisit": [
           "June",
           "July",
           "August",




        ],
        "season": [
           "Summer",


        ],
        "show": "House of Cards",
        "typeOfShow": "Series",
        "rating": 8.7,
        "genre": [
           "Drama",
           "Mystery",
           "Thriller"
        ],
        "feeling": [
           "Dark",
           "Suspenseful",

        ],
        "typeOfHoliday": [
           "Couples Holiday",
           "City Break"
        ],
        "visitType": "City",
        "activities": "19",
        "hotels": 20,
        "restaurants": "2,055",
        "topRestaurants": "Di Pasquale's Italian Marketplace & Deli",
        "placeToVisit": "1609 Park Ave., Baltimore, MD.",
        "male": {
           "under18": "87",
           "18-29": 85,
           "30-44": 88,
           "45Plus": 87
        },
        "female": {
           "under18": "86",
           "18-29": 64,
           "30-44": 87,
           "45Plus": 86
        },
        "other": {
           "under18": "86.5",
           "18-29": 74.5,
           "30-44": 87.5,
           "45Plus": 86.5
        }
     },
      {
        "cityOrCountry": "Boston",
        "country": "Massachusetts, USA",
        "seasonRating": {
           "spring": 19,
           "summer": 28,
           "fall": 17,
           "winter": 3
        },
        "monthsToVisit": [
           "June",
           "July",
           "August",
           "September",
           "October",


        ],
        "season": [
           "Summer",
           "Autumn",

        ],
        "show": "I CARE A LOT",
        "typeOfShow": "Movie",
        "rating": 6.3,
        "genre": [
           "Comedy",
           "Crime",
           "Thriller"
        ],
        "feeling": [
           "Quirky",
           "Witty",

        ],
        "typeOfHoliday": [
           "City Break",
           "Adventure Holiday"
        ],
        "visitType": "State",
        "activities": "5",
        "hotels": 241,
        "restaurants": "2466",
        "topRestaurants": "Mario's Resturant",
        "placeToVisit": "Norfolk County Registry of Deeds in Dedham",
        "male": {
           "under18": "60",
           "18-29": 63,
           "30-44": 63,
           "45Plus": 64
        },
        "female": {
           "under18": "52",
           "18-29": 65,
           "30-44": 65,
           "45Plus": 65
        },
        "other": {
           "under18": "56",
           "18-29": 64,
           "30-44": 64,
           "45Plus": 64.5
        }
     },
      {
        "cityOrCountry": "Los Angeles",
        "country": "California, USA",
        "seasonRating": {
           "spring": 24,
           "summer": 29,
           "fall": 23,
           "winter": 21
        },
        "monthsToVisit": [
           "March",
           "April",
           "May",




        ],
        "season": [
           "Spring",


        ],
        "show": "Lady Dynamite",
        "typeOfShow": "Series",
        "rating": 7.4,
        "genre": [
           "Comedy",
           "Drama",

        ],
        "feeling": [
           "Absurd",
           "Quirky",
           "Feel-Good"
        ],
        "typeOfHoliday": [
           "Couples Holiday",
           "Beach Holiday"
        ],
        "visitType": "City",
        "activities": "50",
        "hotels": 3,
        "restaurants": "13,365",
        "topRestaurants": "n,naka",
        "placeToVisit": "",
        "male": {
           "under18": "-",
           "18-29": 77,
           "30-44": 75,
           "45Plus": 73
        },
        "female": {
           "under18": "-",
           "18-29": 77,
           "30-44": 75,
           "45Plus": 75
        },
        "other": {
           "under18": "-",
           "18-29": 77,
           "30-44": 75,
           "45Plus": 74
        }
     },
      {
        "cityOrCountry": "Los Angeles",
        "country": "California, USA",
        "seasonRating": {
           "spring": 24,
           "summer": 29,
           "fall": 23,
           "winter": 21
        },
        "monthsToVisit": [
           "March",
           "April",
           "May",




        ],
        "season": [
           "Spring",


        ],
        "show": "Lucifer",
        "typeOfShow": "Series",
        "rating": 8.1,
        "genre": [
           "Crime",
           "Mystery",
           "Fantasy"
        ],
        "feeling": [
           "Irreverent",
           "Exciting",

        ],
        "typeOfHoliday": [
           "Adventure Holiday",
           "Beach Holiday"
        ],
        "visitType": "Country Side",
        "activities": "50",
        "hotels": 3,
        "restaurants": "13,365",
        "topRestaurants": "n,naka",
        "placeToVisit": "Warner Bros Burbank studio",
        "male": {
           "under18": "79",
           "18-29": 83,
           "30-44": 82,
           "45Plus": 78
        },
        "female": {
           "under18": "83",
           "18-29": 79,
           "30-44": 84,
           "45Plus": 82
        },
        "other": {
           "under18": "81",
           "18-29": 81,
           "30-44": 83,
           "45Plus": 80
        }
     },
      {
        "cityOrCountry": "Paris",
        "country": "France",
        "seasonRating": {
           "spring": 20,
           "summer": 25,
           "fall": 16,
           "winter": 8
        },
        "monthsToVisit": [
           "June",
           "July",
           "August",




        ],
        "season": [
           "Summer",


        ],
        "show": "Lupin",
        "typeOfShow": "Series",
        "rating": 7.5,
        "genre": [
           "Action",
           "Crime",
           "Thriller"
        ],
        "feeling": [
           "Witty",
           "Exciting",
           "Romantic"
        ],
        "typeOfHoliday": [
           "City Break",
           "Couples Holiday"
        ],
        "visitType": "City",
        "activities": "48",
        "hotels": 79,
        "restaurants": "17,503",
        "topRestaurants": "Il Etait Un Square",
        "placeToVisit": "Louvre",
        "male": {
           "under18": "74",
           "18-29": 78,
           "30-44": 76,
           "45Plus": 74
        },
        "female": {
           "under18": "77",
           "18-29": 58,
           "30-44": 78,
           "45Plus": 76
        },
        "other": {
           "under18": "75.5",
           "18-29": 68,
           "30-44": 77,
           "45Plus": 75
        }
     },
      {
        "cityOrCountry": "Greater Victoria",
        "country": "British Columbia, Canada",
        "seasonRating": {
           "spring": 11,
           "summer": 20,
           "fall": 14,
           "winter": 8
        },
        "monthsToVisit": [
           "September",
           "October",
           "November",




        ],
        "season": [
           "Winter",


        ],
        "show": "Maid",
        "typeOfShow": "Series",
        "rating": 8.4,
        "genre": [
           "Drama",
           "Thriller",

        ],
        "feeling": [
           "Intimate",
           "Emotional",
           "Gritty"
        ],
        "typeOfHoliday": [
           "Couples Holiday",
           "Adventure Holiday"
        ],
        "visitType": "City",
        "activities": "3",
        "hotels": 9,
        "restaurants": "817",
        "topRestaurants": "Saveur Restaurant",
        "placeToVisit": "",
        "male": {
           "under18": "83",
           "18-29": 87,
           "30-44": 84,
           "45Plus": 82
        },
        "female": {
           "under18": "86",
           "18-29": 62,
           "30-44": 86,
           "45Plus": 86
        },
        "other": {
           "under18": "84.5",
           "18-29": 74.5,
           "30-44": 85,
           "45Plus": 84
        }
     },
      {
        "cityOrCountry": "New York City",
        "country": "New York, USA",
        "seasonRating": {
           "spring": 22,
           "summer": 29,
           "fall": 18,
           "winter": 4
        },
        "monthsToVisit": [
           "April",
           "June",





        ],
        "season": [
           "Summer",


        ],
        "show": "Manifest",
        "typeOfShow": "Series",
        "rating": 7.1,
        "genre": [
           "Thriller",
           "Mystery",
           "Sci-Fi"
        ],
        "feeling": [
           "Suspenseful",
           "Emotional",

        ],
        "typeOfHoliday": [
           "Adventure Holiday",
           "City Break"
        ],
        "visitType": "City",
        "activities": "127",
        "hotels": 40,
        "restaurants": "11,406",
        "topRestaurants": "Club A Steakhouse",
        "placeToVisit": "",
        "male": {
           "under18": "69",
           "18-29": 76,
           "30-44": 73,
           "45Plus": 67
        },
        "female": {
           "under18": "75",
           "18-29": 85,
           "30-44": 77,
           "45Plus": 74
        },
        "other": {
           "under18": "72",
           "18-29": 80.5,
           "30-44": 75,
           "45Plus": 70.5
        }
     },
      {
        "cityOrCountry": "Vancouver",
        "country": "British Columbia, Canada",
        "seasonRating": {
           "spring": 17,
           "summer": 22,
           "fall": 14,
           "winter": 7
        },
        "monthsToVisit": [
           "March",
           "April",
           "May",




        ],
        "season": [
           "Spring",


        ],
        "show": "Midnight Mass",
        "typeOfShow": "Series",
        "rating": 7.7,
        "genre": [
           "Drama",
           "Fantasy",
           "Horror"
        ],
        "feeling": [
           "Ominous",
           "Scary",
           "Gritty"
        ],
        "typeOfHoliday": [
           "City Break",
           "Adventure Holiday"
        ],
        "visitType": "City",
        "activities": "90",
        "hotels": 14,
        "restaurants": "2,880",
        "topRestaurants": "Black + Blue",
        "placeToVisit": "",
        "male": {
           "under18": "77",
           "18-29": 81,
           "30-44": 79,
           "45Plus": 77
        },
        "female": {
           "under18": "76",
           "18-29": 66,
           "30-44": 76,
           "45Plus": 76
        },
        "other": {
           "under18": "76.5",
           "18-29": 73.5,
           "30-44": 77.5,
           "45Plus": 76.5
        }
     },
      {
        "cityOrCountry": "Pittsburgh",
        "country": "Pennsylvania, USA",
        "seasonRating": {
           "spring": 16,
           "summer": 28,
           "fall": 17,
           "winter": 2
        },
        "monthsToVisit": [
           "July",
           "August",





        ],
        "season": [
           "Summer",


        ],
        "show": "Mindhunter",
        "typeOfShow": "Series",
        "rating": 8.6,
        "genre": [
           "Crime",
           "Drama",
           "Thriller"
        ],
        "feeling": [
           "Chilling",
           "Scary",
           "Suspenseful"
        ],
        "typeOfHoliday": [
           "Adventure Holiday",
           "City Break"
        ],
        "visitType": "State",
        "activities": "34",
        "hotels": 13,
        "restaurants": "1,870",
        "topRestaurants": "The Melting Pot",
        "placeToVisit": "Benedum Center",
        "male": {
           "under18": "86",
           "18-29": 89,
           "30-44": 87,
           "45Plus": 85
        },
        "female": {
           "under18": "86",
           "18-29": 91,
           "30-44": 86,
           "45Plus": 86
        },
        "other": {
           "under18": "86",
           "18-29": 90,
           "30-44": 86.5,
           "45Plus": 85.5
        }
     },
      {
        "cityOrCountry": "Madrid",
        "country": "Spain",
        "seasonRating": {
           "spring": 22,
           "summer": 32,
           "fall": 19,
           "winter": 12
        },
        "monthsToVisit": [
           "September",
           "October",
           "November",




        ],
        "season": [
           "Winter",


        ],
        "show": "Money Heist",
        "typeOfShow": "Series",
        "rating": 8.2,
        "genre": [
           "Action",
           "Crime",
           "Drama"
        ],
        "feeling": [
           "Suspenseful",
           "Exciting",

        ],
        "typeOfHoliday": [
           "Adventure Holiday",
           "City Break"
        ],
        "visitType": "City",
        "activities": "90",
        "hotels": 13,
        "restaurants": "11,818",
        "topRestaurants": "Los Montes de Galicia",
        "placeToVisit": "La Casa de Papel",
        "male": {
           "under18": "82",
           "18-29": 81,
           "30-44": 82,
           "45Plus": 81
        },
        "female": {
           "under18": "85",
           "18-29": 83,
           "30-44": 86,
           "45Plus": 84
        },
        "other": {
           "under18": "83.5",
           "18-29": 82,
           "30-44": 84,
           "45Plus": 82.5
        }
     },
      {
        "cityOrCountry": "Colombia",
        "country": "",
        "seasonRating": {
           "spring": 28,
           "summer": 40,
           "fall": 27,
           "winter": 19
        },
        "monthsToVisit": [
           "December",
           "January",
           "February",
           "March",
           "April",


        ],
        "season": [
           "Winter",
           "Spring",

        ],
        "show": "Narcos",
        "typeOfShow": "Series",
        "rating": 8.8,
        "genre": [
           "Crime",
           "Biography",

        ],
        "feeling": [
           "Gritty",
           "Dark",
           "Suspenseful"
        ],
        "typeOfHoliday": [

           "Adventure Holiday"
        ],
        "visitType": "City",
        "activities": "833",
        "hotels": 142,
        "restaurants": "4,130",
        "topRestaurants": "Storia D'amore - Zona T",
        "placeToVisit": "",
        "male": {
           "under18": "84",
           "18-29": 80,
           "30-44": 84,
           "45Plus": 83
        },
        "female": {
           "under18": "83",
           "18-29": 77,
           "30-44": 83,
           "45Plus": 82
        },
        "other": {
           "under18": "83.5",
           "18-29": 78.5,
           "30-44": 83.5,
           "45Plus": 82.5
        }
     },
      {
        "cityOrCountry": "Sherman Oaks",
        "country": "California, USA",
        "seasonRating": {
           "spring": 24,
           "summer": 35,
           "fall": 25,
           "winter": 21
        },
        "monthsToVisit": [
           "March",
           "April",
           "May",




        ],
        "season": [
           "Spring",


        ],
        "show": "Never Have I Ever",
        "typeOfShow": "Series",
        "rating": 7.8,
        "genre": [
           "Comedy",
           "Drama",

        ],
        "feeling": [
           "Quirky",
           "Witty",

        ],
        "typeOfHoliday": [
           "Couples Holiday",
           "Adventure Holiday"
        ],
        "visitType": "City",
        "activities": "389",
        "hotels": 3,
        "restaurants": "13,365",
        "topRestaurants": "n,naka",
        "placeToVisit": "Universal Studios",
        "male": {
           "under18": "77",
           "18-29": 74,
           "30-44": 77,
           "45Plus": 77
        },
        "female": {
           "under18": "80",
           "18-29": 72,
           "30-44": 78,
           "45Plus": 81
        },
        "other": {
           "under18": "78.5",
           "18-29": 73,
           "30-44": 77.5,
           "45Plus": 79
        }
     },
      {
        "cityOrCountry": "Charleston",
        "country": "South Carolina, USA",
        "seasonRating": {
           "spring": 26,
           "summer": 31,
           "fall": 20,
           "winter": 16
        },
        "monthsToVisit": [
           "March",
           "April",
           "May",




        ],
        "season": [
           "Spring",


        ],
        "show": "Outer Banks",
        "typeOfShow": "Series",
        "rating": 7.6,
        "genre": [
           "Action",
           "Crime",
           "Adventure"
        ],
        "feeling": [
           "Suspenseful",
           "Emotional",

        ],
        "typeOfHoliday": [
           "City Break",
           "Couples Holiday"
        ],
        "visitType": "Town",
        "activities": "14",
        "hotels": 4,
        "restaurants": "646",
        "topRestaurants": "Halls Chophouse",
        "placeToVisit": "Mount Pleasant's Shem Creek",
        "male": {
           "under18": "73",
           "18-29": 81,
           "30-44": 76,
           "45Plus": 73
        },
        "female": {
           "under18": "76",
           "18-29": 66,
           "30-44": 77,
           "45Plus": 75
        },
        "other": {
           "under18": "74.5",
           "18-29": 73.5,
           "30-44": 76.5,
           "45Plus": 74
        }
     },
      {
        "cityOrCountry": "Lake of the Ozarks",
        "country": "Missouri, USA",
        "seasonRating": {
           "spring": 25,
           "summer": 32,
           "fall": 22,
           "winter": 6
        },
        "monthsToVisit": [
           "May",
           "June",
           "July",
           "August",
           "September",


        ],
        "season": [
           "Spring",
           "Summer",
           "Autumn"
        ],
        "show": "Ozark",
        "typeOfShow": "Series",
        "rating": 8.4,
        "genre": [
           "Crime",
           "Drama",
           "Thriller"
        ],
        "feeling": [
           "Ominous",
           "Dark",
           "Violent"
        ],
        "typeOfHoliday": [
           "Adventure Holiday",
           "Remote"
        ],
        "visitType": "Town",
        "activities": "55",
        "hotels": 2,
        "restaurants": "242",
        "topRestaurants": "JB Hook's",
        "placeToVisit": "",
        "male": {
           "under18": "84",
           "18-29": 88,
           "30-44": 85,
           "45Plus": 84
        },
        "female": {
           "under18": "84",
           "18-29": 87,
           "30-44": 83,
           "45Plus": 83
        },
        "other": {
           "under18": "84",
           "18-29": 87.5,
           "30-44": 84,
           "45Plus": 83.5
        }
     },
      {
        "cityOrCountry": "New York City",
        "country": "New York, USA",
        "seasonRating": {
           "spring": 22,
           "summer": 29,
           "fall": 18,
           "winter": 4
        },
        "monthsToVisit": [
           "April",
           "May",
           "June",




        ],
        "season": [
           "Summer",


        ],
        "show": "Passing",
        "typeOfShow": "Movie",
        "rating": 6.7,
        "genre": [
           "Drama",
           "Romance",

        ],
        "feeling": [
           "Intimate",
           "Suspenseful",

        ],
        "typeOfHoliday": [
           "Adventure Holiday",
           "City Break"
        ],
        "visitType": "City",
        "activities": "127",
        "hotels": 40,
        "restaurants": "11,406",
        "topRestaurants": "Club A Steakhouse",
        "placeToVisit": "",
        "male": {
           "under18": "69",
           "18-29": 69,
           "30-44": 66,
           "45Plus": 65
        },
        "female": {
           "under18": "52",
           "18-29": 67,
           "30-44": 66,
           "45Plus": 68
        },
        "other": {
           "under18": "60.5",
           "18-29": 68,
           "30-44": 66,
           "45Plus": 66.5
        }
     },
      {
        "cityOrCountry": "Atlanta",
        "country": "Georgia, USA",
        "seasonRating": {
           "spring": 17,
           "summer": 32,
           "fall": 12,
           "winter": 10
        },
        "monthsToVisit": [
           "May",
           "June",
           "September",




        ],
        "season": [
           "Spring",
           "Summer",
           "Autumn"
        ],
        "show": "Raising Dion",
        "typeOfShow": "Series",
        "rating": 7.2,
        "genre": [
           "Drama",
           "Sci-Fi",
           "Fantasy"
        ],
        "feeling": [
           "Heartfelt",
           "Feel-Good",
           "Exciting"
        ],
        "typeOfHoliday": [
           "City Break",
           "Adventure Holiday"
        ],
        "visitType": "State",
        "activities": "491",
        "hotels": 15,
        "restaurants": "3,396",
        "topRestaurants": "Aviva by Kameel",
        "placeToVisit": "Fox Theatre",
        "male": {
           "under18": "69",
           "18-29": 73,
           "30-44": 70,
           "45Plus": 69
        },
        "female": {
           "under18": "77",
           "18-29": 82,
           "30-44": 77,
           "45Plus": 77
        },
        "other": {
           "under18": "73",
           "18-29": 77.5,
           "30-44": 73.5,
           "45Plus": 73
        }
     },
      {
        "cityOrCountry": "Monterey",
        "country": "California, USA",
        "seasonRating": {
           "spring": 19,
           "summer": 21,
           "fall": 19,
           "winter": 16
        },
        "monthsToVisit": [
           "March",
           "April",
           "May",




        ],
        "season": [
           "Summer",


        ],
        "show": "Ratched",
        "typeOfShow": "Series",
        "rating": 7.3,
        "genre": [
           "Crime",
           "Horror",
           "Mystery"
        ],
        "feeling": [
           "Ominous",
           "Dark",
           "Suspenseful"
        ],
        "typeOfHoliday": [
           "Beach Holiday",
           "Remote"
        ],
        "visitType": "Town",
        "activities": "19",
        "hotels": 3,
        "restaurants": "407",
        "topRestaurants": "Compagno's Market & Deli",
        "placeToVisit": "Toro Place Cafe",
        "male": {
           "under18": "71",
           "18-29": 62,
           "30-44": 72,
           "45Plus": 71
        },
        "female": {
           "under18": "74",
           "18-29": 62,
           "30-44": 74,
           "45Plus": 74
        },
        "other": {
           "under18": "72.5",
           "18-29": 62,
           "30-44": 73,
           "45Plus": 72.5
        }
     },
      {
        "cityOrCountry": "Atlanta",
        "country": "Georgia, USA",
        "seasonRating": {
           "spring": 27,
           "summer": 31,
           "fall": 28,
           "winter": 18
        },
        "monthsToVisit": [
           "March",
           "April",
           "May",




        ],
        "season": [
           "Spring",


        ],
        "show": "RED NOTICE",
        "typeOfShow": "Movie",
        "rating": 6.3,
        "genre": [
           "Action",
           "Comedy",
           "Thriller"
        ],
        "feeling": [
           "Exciting",
           "Irreverent",
           "Romantic"
        ],
        "typeOfHoliday": [
           "City Break",
           "Adventure Holiday"
        ],
        "visitType": "City",
        "activities": "9",
        "hotels": 293,
        "restaurants": "3397",
        "topRestaurants": "Aviva by Kameel",
        "placeToVisit": "Tyler Perry Studio",
        "male": {
           "under18": "64",
           "18-29": 63,
           "30-44": 63,
           "45Plus": 64
        },
        "female": {
           "under18": "64",
           "18-29": 65,
           "30-44": 66,
           "45Plus": 69
        },
        "other": {
           "under18": "64",
           "18-29": 64,
           "30-44": 64.5,
           "45Plus": 66.5
        }
     },
      {
        "cityOrCountry": "New York City",
        "country": "New York, USA",
        "seasonRating": {
           "spring": 22,
           "summer": 29,
           "fall": 18,
           "winter": 4
        },
        "monthsToVisit": [
           "April",
           "June",





        ],
        "season": [
           "Summer",


        ],
        "show": "Riverdale",
        "typeOfShow": "Series",
        "rating": 6.7,
        "genre": [
           "Crime",
           "Drama",
           "Mystery"
        ],
        "feeling": [
           "Offbeat",
           "Dark",
           "Emotional"
        ],
        "typeOfHoliday": [
           "Adventure Holiday",
           "City Break"
        ],
        "visitType": "Town",
        "activities": "127",
        "hotels": 40,
        "restaurants": "11,406",
        "topRestaurants": "Club A Steakhouse",
        "placeToVisit": "Rocko’s Family Diner",
        "male": {
           "under18": "67",
           "18-29": 55,
           "30-44": 68,
           "45Plus": 67
        },
        "female": {
           "under18": "70",
           "18-29": 51,
           "30-44": 69,
           "45Plus": 71
        },
        "other": {
           "under18": "68.5",
           "18-29": 53,
           "30-44": 68.5,
           "45Plus": 69
        }
     },
      {
        "cityOrCountry": "Harlem",
        "country": "New York, USA",
        "seasonRating": {
           "spring": 22,
           "summer": 29,
           "fall": 13,
           "winter": 4
        },
        "monthsToVisit": [
           "April",
           "June",





        ],
        "season": [
           "Summer",


        ],
        "show": "Russian Doll",
        "typeOfShow": "Series",
        "rating": 7.8,
        "genre": [
           "Adventure",
           "Comedy",
           "Mystery"
        ],
        "feeling": [
           "Quirky",
           "Witty",
           "Mind-bending"
        ],
        "typeOfHoliday": [
           "Couples Holiday",
           "Adventure Holiday"
        ],
        "visitType": "City",
        "activities": "37",
        "hotels": 15,
        "restaurants": "11,406",
        "topRestaurants": "Club A Steakhouse",
        "placeToVisit": "120th Street between Lenox Avenue",
        "male": {
           "under18": "78",
           "18-29": 81,
           "30-44": 79,
           "45Plus": 78
        },
        "female": {
           "under18": "80",
           "18-29": 74,
           "30-44": 80,
           "45Plus": 80
        },
        "other": {
           "under18": "79",
           "18-29": 77.5,
           "30-44": 79.5,
           "45Plus": 79
        }
     },
      {
        "cityOrCountry": "Ontario",
        "country": "Canada",
        "seasonRating": {
           "spring": 8,
           "summer": 27,
           "fall": 19,
           "winter": 11
        },
        "monthsToVisit": [
           "May",
           "June",
           "July",
           "August",
           "September",


        ],
        "season": [
           "Spring",
           "Summer",
           "Autumn"
        ],
        "show": "Schitt's Creek",
        "typeOfShow": "Series",
        "rating": 8.5,
        "genre": [
           "Comedy",
           "Drama",
           "Romance"
        ],
        "feeling": [
           "Witty",
           "Irreverent",
           "Feel-Good"
        ],
        "typeOfHoliday": [
           "City Break",
           "Adventure Holiday"
        ],
        "visitType": "Town",
        "activities": "67",
        "hotels": 30,
        "restaurants": "7,696",
        "topRestaurants": "Goodfellas Wood Oven Pizza",
        "placeToVisit": "Applewood Farm and Winery",
        "male": {
           "under18": "83",
           "18-29": 80,
           "30-44": 84,
           "45Plus": 83
        },
        "female": {
           "under18": "88",
           "18-29": 78,
           "30-44": 87,
           "45Plus": 88
        },
        "other": {
           "under18": "85.5",
           "18-29": 79,
           "30-44": 85.5,
           "45Plus": 85.5
        }
     },
      {
        "cityOrCountry": "Los Angeles",
        "country": "California, USA",
        "seasonRating": {
           "spring": 24,
           "summer": 29,
           "fall": 23,
           "winter": 21
        },
        "monthsToVisit": [
           "March",
           "April",
           "May",




        ],
        "season": [
           "Spring",


        ],
        "show": "Seinfeld",
        "typeOfShow": "Series",
        "rating": 8.8,
        "genre": [
           "Comedy",
           "Romance",

        ],
        "feeling": [
           "Witty",
           "Irreverent",

        ],
        "typeOfHoliday": [
           "Couples Holiday",
           "Beach Holiday"
        ],
        "visitType": "City",
        "activities": "50",
        "hotels": 3,
        "restaurants": "13,365",
        "topRestaurants": "n,naka",
        "placeToVisit": "",
        "male": {
           "under18": "89",
           "18-29": 88,
           "30-44": 89,
           "45Plus": 9
        },
        "female": {
           "under18": "83",
           "18-29": 80,
           "30-44": 84,
           "45Plus": 83
        },
        "other": {
           "under18": "86",
           "18-29": 84,
           "30-44": 86.5,
           "45Plus": 46
        }
     },
      {
        "cityOrCountry": "Baja California",
        "country": "Mexico",
        "seasonRating": {
           "spring": 14,
           "summer": 21,
           "fall": 8,
           "winter": 0
        },
        "monthsToVisit": [
           "January",
           "February",
           "March",




        ],
        "season": [
           "Winter",
           "Spring",

        ],
        "show": "Selena: The Series",
        "typeOfShow": "Series",
        "rating": 6.9,
        "genre": [
           "Biography",
           "Drama",
           "Music"
        ],
        "feeling": [
           "Inspiring",
           "Feel-Good",

        ],
        "typeOfHoliday": [
           "Couples Holiday",
           "Beach Holiday"
        ],
        "visitType": "State",
        "activities": "65",
        "hotels": 30,
        "restaurants": "798",
        "topRestaurants": "Condimento Restaurant",
        "placeToVisit": "",
        "male": {
           "under18": "68",
           "18-29": 90,
           "30-44": 69,
           "45Plus": 68
        },
        "female": {
           "under18": "70",
           "18-29": 25,
           "30-44": 69,
           "45Plus": 70
        },
        "other": {
           "under18": "69",
           "18-29": 57.5,
           "30-44": 69,
           "45Plus": 69
        }
     },
      {
        "cityOrCountry": "Forest of Dean",
        "country": "England, UK",
        "seasonRating": {
           "spring": 17,
           "summer": 21,
           "fall": 16,
           "winter": 2
        },
        "monthsToVisit": [
           "March",
           "April",
           "May",




        ],
        "season": [
           "Summer",


        ],
        "show": "Sex Education",
        "typeOfShow": "Series",
        "rating": 8.3,
        "genre": [
           "Comedy",
           "Drama",

        ],
        "feeling": [
           "Raunchy",
           "Heartfelt",
           "Irreverent"
        ],
        "typeOfHoliday": [
           "Adventure Holiday",
           "Remote"
        ],
        "visitType": "Town",
        "activities": "21",
        "hotels": 102,
        "restaurants": "301",
        "topRestaurants": "The Globe Inn Alvington",
        "placeToVisit": "Wye Valley, Caerleon campus",
        "male": {
           "under18": "83",
           "18-29": 83,
           "30-44": 83,
           "45Plus": 83
        },
        "female": {
           "under18": "85",
           "18-29": 79,
           "30-44": 85,
           "45Plus": 85
        },
        "other": {
           "under18": "84",
           "18-29": 81,
           "30-44": 84,
           "45Plus": 84
        }
     },
      {
        "cityOrCountry": "Budapest",
        "country": "Hungary",
        "seasonRating": {
           "spring": 23,
           "summer": 28,
           "fall": 23,
           "winter": 3
        },
        "monthsToVisit": [
           "March",
           "April",
           "May",




        ],
        "season": [
           "Spring",


        ],
        "show": "Shadow and Bone",
        "typeOfShow": "Series",
        "rating": 7.7,
        "genre": [
           "Action",
           "Adventure",
           "Fantasy"
        ],
        "feeling": [
           "Ominous",
           "Suspenseful",
           "Emotional"
        ],
        "typeOfHoliday": [
           "Couples Holiday",
           "Adventure Holiday"
        ],
        "visitType": "City",
        "activities": "40",
        "hotels": 15,
        "restaurants": "3,121",
        "topRestaurants": "Beerstro 14",
        "placeToVisit": "Budapest's ancient Castle Quarter",
        "male": {
           "under18": "75",
           "18-29": 79,
           "30-44": 77,
           "45Plus": 74
        },
        "female": {
           "under18": "79",
           "18-29": 66,
           "30-44": 81,
           "45Plus": 78
        },
        "other": {
           "under18": "77",
           "18-29": 72.5,
           "30-44": 79,
           "45Plus": 76
        }
     },
      {
        "cityOrCountry": "Incheon",
        "country": "South Korea",
        "seasonRating": {
           "spring": 21,
           "summer": 29,
           "fall": 20,
           "winter": 2
        },
        "monthsToVisit": [
           "November",
           "December",
           "January",
           "February",
           "March",


        ],
        "season": [
           "Autumn",
           "Winter",

        ],
        "show": "Squid Game",
        "typeOfShow": "Series",
        "rating": 8,
        "genre": [
           "Action",
           "Drama",
           "Mystery"
        ],
        "feeling": [
           "Suspenseful",
           "Emotional",
           "Violent"
        ],
        "typeOfHoliday": [
           "City Break",
           "Adventure Holiday"
        ],
        "visitType": "Island",
        "activities": "18",
        "hotels": 75,
        "restaurants": "4,993",
        "topRestaurants": "The Cinder Bar",
        "placeToVisit": "Seongapdo Island, Incheon",
        "male": {
           "under18": "80",
           "18-29": 82,
           "30-44": 80,
           "45Plus": 80
        },
        "female": {
           "under18": "81",
           "18-29": 83,
           "30-44": 82,
           "45Plus": 81
        },
        "other": {
           "under18": "80.5",
           "18-29": 82.5,
           "30-44": 81,
           "45Plus": 80.5
        }
     },
      {
        "cityOrCountry": "Atlanta",
        "country": "Georgia, USA",
        "seasonRating": {
           "spring": 27,
           "summer": 31,
           "fall": 28,
           "winter": 18
        },
        "monthsToVisit": [
           "March",
           "April",
           "May",




        ],
        "season": [
           "Spring",


        ],
        "show": "Stranger Things",
        "typeOfShow": "Series",
        "rating": 8.7,
        "genre": [
           "Drama",
           "Fantasy",
           "Horror"
        ],
        "feeling": [
           "Ominous",
           "Scary",
           "Exciting"
        ],
        "typeOfHoliday": [
           "City Break",
           "Adventure Holiday"
        ],
        "visitType": "Town",
        "activities": "9",
        "hotels": 4,
        "restaurants": "3,396",
        "topRestaurants": "Aviva by Kameel",
        "placeToVisit": "EUE Screen Gems Studios",
        "male": {
           "under18": "87",
           "18-29": 87,
           "30-44": 87,
           "45Plus": 887
        },
        "female": {
           "under18": "88",
           "18-29": 77,
           "30-44": 88,
           "45Plus": 88
        },
        "other": {
           "under18": "87.5",
           "18-29": 82,
           "30-44": 87.5,
           "45Plus": 487.5
        }
     },
      {
        "cityOrCountry": "Auckland",
        "country": "New Zealand",
        "seasonRating": {
           "spring": 20,
           "summer": 24,
           "fall": 23,
           "winter": 15
        },
        "monthsToVisit": [
           "September",
           "October",
           "November",




        ],
        "season": [
           "Winter",


        ],
        "show": "Sweet Tooth",
        "typeOfShow": "Series",
        "rating": 7.8,
        "genre": [
           "Action",
           "Adventure",
           "Drama"
        ],
        "feeling": [
           "Quirky",
           "Heartfelt",

        ],
        "typeOfHoliday": [
           "Couples Holiday",
           "City Break"
        ],
        "visitType": "City",
        "activities": "696",
        "hotels": 138,
        "restaurants": "3,772",
        "topRestaurants": "Ahi",
        "placeToVisit": "Rainbow's End",
        "male": {
           "under18": "77",
           "18-29": 81,
           "30-44": 78,
           "45Plus": 77
        },
        "female": {
           "under18": "81",
           "18-29": 67,
           "30-44": 80,
           "45Plus": 81
        },
        "other": {
           "under18": "79",
           "18-29": 74,
           "30-44": 79,
           "45Plus": 79
        }
     },
      {
        "cityOrCountry": "London",
        "country": "England, UK",
        "seasonRating": {
           "spring": 18,
           "summer": 23,
           "fall": 16,
           "winter": 9
        },
        "monthsToVisit": [
           "March",
           "April",
           "May",




        ],
        "season": [
           "Spring",


        ],
        "show": "The Crown",
        "typeOfShow": "Series",
        "rating": 8.6,
        "genre": [
           "Biography",
           "Drama",
           "History"
        ],
        "feeling": [
           "Intimate",
           "Romantic",
           "Emotional"
        ],
        "typeOfHoliday": [
           "Adventure Holiday",
           "City Break"
        ],
        "visitType": "Country Side",
        "activities": "77",
        "hotels": 141,
        "restaurants": "20,375",
        "topRestaurants": "Hibox",
        "placeToVisit": "Belvoir Castle.",
        "male": {
           "under18": "86",
           "18-29": 87,
           "30-44": 87,
           "45Plus": 86
        },
        "female": {
           "under18": "87",
           "18-29": 84,
           "30-44": 87,
           "45Plus": 87
        },
        "other": {
           "under18": "86.5",
           "18-29": 85.5,
           "30-44": 87,
           "45Plus": 86.5
        }
     },
      {
        "cityOrCountry": "Surrey",
        "country": "England, UK",
        "seasonRating": {
           "spring": 13,
           "summer": 22,
           "fall": 14,
           "winter": 7
        },
        "monthsToVisit": [
           "September",
           "October",
           "November",
           "December",



        ],
        "season": [
           "Winter",


        ],
        "show": "The Dig",
        "typeOfShow": "Movie",
        "rating": 7.1,
        "genre": [
           "Drama",
           "Biography",
           "History"
        ],
        "feeling": [
           "Emotional",
           "Suspenseful",

        ],
        "typeOfHoliday": [
           "Adventure Holiday",
           "Remote"
        ],
        "visitType": "Town",
        "activities": "170",
        "hotels": 467,
        "restaurants": "2187",
        "topRestaurants": "Bacaro",
        "placeToVisit": "Shackleford",
        "male": {
           "under18": "67",
           "18-29": 70,
           "30-44": 70,
           "45Plus": 72
        },
        "female": {
           "under18": "62",
           "18-29": 72,
           "30-44": 71,
           "45Plus": 75
        },
        "other": {
           "under18": "64.5",
           "18-29": 71,
           "30-44": 70.5,
           "45Plus": 73.5
        }
     },
      {
        "cityOrCountry": "London",
        "country": "England, UK",
        "seasonRating": {
           "spring": 18,
           "summer": 23,
           "fall": 16,
           "winter": 9
        },
        "monthsToVisit": [
           "March",
           "April",
           "May",




        ],
        "season": [
           "Spring",


        ],
        "show": "The Duchess",
        "typeOfShow": "Series",
        "rating": 6.8,
        "genre": [
           "Biography",
           "Drama",
           "History"
        ],
        "feeling": [
           "Intimate",
           "Emotional",

        ],
        "typeOfHoliday": [
           "Couples Holiday",
           "City Break"
        ],
        "visitType": "City",
        "activities": "77",
        "hotels": 141,
        "restaurants": "20,375",
        "topRestaurants": "Hibox",
        "placeToVisit": "Kedleston Hall",
        "male": {
           "under18": "67",
           "18-29": 72,
           "30-44": 67,
           "45Plus": 66
        },
        "female": {
           "under18": "71",
           "18-29": 68,
           "30-44": 72,
           "45Plus": 70
        },
        "other": {
           "under18": "69",
           "18-29": 70,
           "30-44": 69.5,
           "45Plus": 68
        }
     },
      {
        "cityOrCountry": "Paris",
        "country": "France",
        "seasonRating": {
           "spring": 20,
           "summer": 25,
           "fall": 16,
           "winter": 8
        },
        "monthsToVisit": [
           "June",
           "July",
           "August",




        ],
        "season": [
           "Summer",


        ],
        "show": "The Eddy",
        "typeOfShow": "Series",
        "rating": 7.2,
        "genre": [
           "Drama",
           "Music",
           "Crime"
        ],
        "feeling": [
           "Intimate",
           "Emotional",
           "Suspenseful"
        ],
        "typeOfHoliday": [
           "Adventure Holiday",
           "Couples Holiday"
        ],
        "visitType": "City",
        "activities": "48",
        "hotels": 79,
        "restaurants": "17,503",
        "topRestaurants": "Il Etait Un Square",
        "placeToVisit": "",
        "male": {
           "under18": "-",
           "18-29": 74,
           "30-44": 71,
           "45Plus": 72
        },
        "female": {
           "under18": "-",
           "18-29": 70,
           "30-44": 70,
           "45Plus": 65
        },
        "other": {
           "under18": "-",
           "18-29": 72,
           "30-44": 70.5,
           "45Plus": 68.5
        }
     },
      {
        "cityOrCountry": "Hollywood",
        "country": "California, USA",
        "seasonRating": {
           "spring": 24,
           "summer": 32,
           "fall": 24,
           "winter": 17
        },
        "monthsToVisit": [
           "March",
           "April",
           "May",




        ],
        "season": [
           "Spring",


        ],
        "show": "The Good Place",
        "typeOfShow": "Series",
        "rating": 8.2,
        "genre": [
           "Comedy",
           "Drama",
           "Fantasy"
        ],
        "feeling": [
           "Quirky",
           "Witty",
           "Feel-Good"
        ],
        "typeOfHoliday": [
           "Couples Holiday",
           "Beach Holiday"
        ],
        "visitType": "City",
        "activities": "6",
        "hotels": 12,
        "restaurants": "1,827",
        "topRestaurants": "Cvi.Che 105",
        "placeToVisit": "Universal Studios in Hollywood",
        "male": {
           "under18": "82",
           "18-29": 84,
           "30-44": 83,
           "45Plus": 81
        },
        "female": {
           "under18": "82",
           "18-29": 79,
           "30-44": 83,
           "45Plus": 82
        },
        "other": {
           "under18": "82",
           "18-29": 81.5,
           "30-44": 83,
           "45Plus": 81.5
        }
     },
      {
        "cityOrCountry": "Santa Fe",
        "country": "New Mexico, USA",
        "seasonRating": {
           "spring": 22,
           "summer": 30,
           "fall": 11,
           "winter": 6
        },
        "monthsToVisit": [
           "September",
           "October",
           "November",




        ],
        "season": [
           "Winter",


        ],
        "show": "The Harder They Fall",
        "typeOfShow": "Movie",
        "rating": 6.6,
        "genre": [
           "Drama",
           "Romance",
           "Western"
        ],
        "feeling": [
           "Quirky",
           "Witty",
           "Violent"
        ],
        "typeOfHoliday": [
           "City Break",
           "Adventure Holiday"
        ],
        "visitType": "State",
        "activities": "59",
        "hotels": 119,
        "restaurants": "383",
        "topRestaurants": "Sazon",
        "placeToVisit": "",
        "male": {
           "under18": "70",
           "18-29": 67,
           "30-44": 64,
           "45Plus": 62
        },
        "female": {
           "under18": "90",
           "18-29": 69,
           "30-44": 70,
           "45Plus": 71
        },
        "other": {
           "under18": "80",
           "18-29": 68,
           "30-44": 67,
           "45Plus": 66.5
        }
     },
      {
        "cityOrCountry": "Vancouver",
        "country": "British Columbia, Canada",
        "seasonRating": {
           "spring": 17,
           "summer": 22,
           "fall": 14,
           "winter": 7
        },
        "monthsToVisit": [
           "March",
           "April",
           "May",




        ],
        "season": [
           "Spring",


        ],
        "show": "The Haunting of Bly Manor",
        "typeOfShow": "Series",
        "rating": 7.4,
        "genre": [
           "Drama",
           "Horror",
           "Mystery"
        ],
        "feeling": [
           "Ominous",
           "Scary",
           "Dark"
        ],
        "typeOfHoliday": [
           "City Break",
           "Adventure Holiday"
        ],
        "visitType": "Haunted Town",
        "activities": "86",
        "hotels": 14,
        "restaurants": "2,880",
        "topRestaurants": "Black + Blue",
        "placeToVisit": "Cecil Green Park House",
        "male": {
           "under18": "85",
           "18-29": 89,
           "30-44": 87,
           "45Plus": 85
        },
        "female": {
           "under18": "87",
           "18-29": 82,
           "30-44": 87,
           "45Plus": 87
        },
        "other": {
           "under18": "86",
           "18-29": 85.5,
           "30-44": 87,
           "45Plus": 86
        }
     },
      {
        "cityOrCountry": "New York City",
        "country": "New York, USA",
        "seasonRating": {
           "spring": 22,
           "summer": 29,
           "fall": 18,
           "winter": 4
        },
        "monthsToVisit": [
           "April",
           "May",
           "June",




        ],
        "season": [
           "Summer",


        ],
        "show": "The Irishman",
        "typeOfShow": "Movie",
        "rating": 7.8,
        "genre": [
           "Biography",
           "Crime",
           "Drama"
        ],
        "feeling": [
           "Gritty",
           "Suspenseful",
           "Violent"
        ],
        "typeOfHoliday": [
           "Adventure Holiday",
           "City Break"
        ],
        "visitType": "State",
        "activities": "26",
        "hotels": 9,
        "restaurants": "11,406",
        "topRestaurants": "Club A Steakhouse",
        "placeToVisit": "Lafayette Theater, Theatre where many of the scenes were shot",
        "male": {
           "under18": "78",
           "18-29": 83,
           "30-44": 81,
           "45Plus": 77
        },
        "female": {
           "under18": "74",
           "18-29": 76,
           "30-44": 75,
           "45Plus": 73
        },
        "other": {
           "under18": "76",
           "18-29": 79.5,
           "30-44": 78,
           "45Plus": 75
        }
     },
      {
        "cityOrCountry": "Chicago",
        "country": "Illinois, USA",
        "seasonRating": {
           "spring": 19,
           "summer": 28,
           "fall": 10,
           "winter": 0
        },
        "monthsToVisit": [
           "October",
           "April",
           "May",




        ],
        "season": [
           "Autumn",
           "Spring",

        ],
        "show": "The Last Dance",
        "typeOfShow": "Series",
        "rating": 9.1,
        "genre": [
           "Documentary",
           "Biography",
           "History"
        ],
        "feeling": [
           "Feel-Good",
           "Exciting",
           "Inspiring"
        ],
        "typeOfHoliday": [
           "City Break",
           "Adventure Holiday"
        ],
        "visitType": "City",
        "activities": "5",
        "hotels": 9,
        "restaurants": "8,863",
        "topRestaurants": " The Polo Inn Bridgeport U.S.A.",
        "placeToVisit": "United Center",
        "male": {
           "under18": "91",
           "18-29": 96,
           "30-44": 92,
           "45Plus": 91
        },
        "female": {
           "under18": "89",
           "18-29": 69,
           "30-44": 90,
           "45Plus": 89
        },
        "other": {
           "under18": "90",
           "18-29": 82.5,
           "30-44": 91,
           "45Plus": 90
        }
     },
      {
        "cityOrCountry": "Spetses",
        "country": "Greece",
        "seasonRating": {
           "spring": 18,
           "summer": 26,
           "fall": 22,
           "winter": 18
        },
        "monthsToVisit": [
           "April",
           "May",
           "June",




        ],
        "season": [
           "Summer",


        ],
        "show": "The Lost Daughter",
        "typeOfShow": "Movie",
        "rating": 6.8,
        "genre": [
           "Drama",
           "Mystery",
           "Thriller"
        ],
        "feeling": [
           "Intimate",
           "Dark",
           "Suspenseful"
        ],
        "typeOfHoliday": [
           "Remote",
           "Couples Holiday"
        ],
        "visitType": "Island",
        "activities": "12",
        "hotels": 74,
        "restaurants": "60",
        "topRestaurants": "Cielo Mar All Day Bar",
        "placeToVisit": "Kyopeli's beach",
        "male": {
           "under18": "73",
           "18-29": 70,
           "30-44": 68,
           "45Plus": 66
        },
        "female": {
           "under18": "59",
           "18-29": 69,
           "30-44": 69,
           "45Plus": 67
        },
        "other": {
           "under18": "66",
           "18-29": 69.5,
           "30-44": 68.5,
           "45Plus": 66.5
        }
     },
      {
        "cityOrCountry": "London",
        "country": "England, UK",
        "seasonRating": {
           "spring": 18,
           "summer": 23,
           "fall": 16,
           "winter": 9
        },
        "monthsToVisit": [
           "March",
           "April",
           "May",




        ],
        "season": [
           "Spring",


        ],
        "show": "The One",
        "typeOfShow": "Series",
        "rating": 6.6,
        "genre": [
           "Crime",
           "Mystery",
           "Sci-Fi"
        ],
        "feeling": [
           "Emotional",
           "Suspenseful",

        ],
        "typeOfHoliday": [
           "Couples Holiday",
           "City Break"
        ],
        "visitType": "City",
        "activities": "77",
        "hotels": 141,
        "restaurants": "20,375",
        "topRestaurants": "Hibox",
        "placeToVisit": "",
        "male": {
           "under18": "60",
           "18-29": 65,
           "30-44": 64,
           "45Plus": 65
        },
        "female": {
           "under18": "48",
           "18-29": 66,
           "30-44": 66,
           "45Plus": 66
        },
        "other": {
           "under18": "54",
           "18-29": 65.5,
           "30-44": 65,
           "45Plus": 65.5
        }
     },
      {
        "cityOrCountry": "Queenstown",
        "country": "New Zealand",
        "seasonRating": {
           "spring": 18,
           "summer": 22,
           "fall": 15,
           "winter": 8
        },
        "monthsToVisit": [
           "June",
           "July",
           "August",




        ],
        "season": [
           "Summer",


        ],
        "show": "The Power of the Dog",
        "typeOfShow": "Movie",
        "rating": 7,
        "genre": [
           "Drama",
           "Romance",
           "Western"
        ],
        "feeling": [
           "Ominous",
           "Emotional",

        ],
        "typeOfHoliday": [
           "Couples Holiday",
           "Adventure Holiday"
        ],
        "visitType": "Town",
        "activities": "139",
        "hotels": 267,
        "restaurants": "198",
        "topRestaurants": "Blue Kanu",
        "placeToVisit": "Cecil Peak",
        "male": {
           "under18": "74",
           "18-29": 71,
           "30-44": 69,
           "45Plus": 69
        },
        "female": {
           "under18": "67",
           "18-29": 71,
           "30-44": 70,
           "45Plus": 72
        },
        "other": {
           "under18": "70.5",
           "18-29": 71,
           "30-44": 69.5,
           "45Plus": 70.5
        }
     },
      {
        "cityOrCountry": "Berlin",
        "country": "Germany",
        "seasonRating": {
           "spring": 19,
           "summer": 24,
           "fall": 19,
           "winter": 3
        },
        "monthsToVisit": [
           "May",
           "June",
           "July",
           "August",
           "September",


        ],
        "season": [
           "Spring",
           "Summer",
           "Autumn"
        ],
        "show": "The Queen’s Gambit",
        "typeOfShow": "Series",
        "rating": 8.6,
        "genre": [
           "Drama",
           "Romance",

        ],
        "feeling": [
           "Intimate",
           "Emotional",

        ],
        "typeOfHoliday": [
           "Couples Holiday",
           "City Break"
        ],
        "visitType": "Town",
        "activities": "20",
        "hotels": 26,
        "restaurants": "6,333",
        "topRestaurants": "100 Gramm Bar",
        "placeToVisit": "Bode Museum",
        "male": {
           "under18": "85",
           "18-29": 88,
           "30-44": 86,
           "45Plus": 85
        },
        "female": {
           "under18": "87",
           "18-29": 85,
           "30-44": 87,
           "45Plus": 86
        },
        "other": {
           "under18": "86",
           "18-29": 86.5,
           "30-44": 86.5,
           "45Plus": 85.5
        }
     },
      {
        "cityOrCountry": "New York City",
        "country": "New York, USA",
        "seasonRating": {
           "spring": 22,
           "summer": 29,
           "fall": 18,
           "winter": 4
        },
        "monthsToVisit": [
           "April",
           "June",





        ],
        "season": [
           "Summer",


        ],
        "show": "THE SINNER",
        "typeOfShow": "Series",
        "rating": 7.9,
        "genre": [
           "Crime",
           "Drama",
           "Mystery"
        ],
        "feeling": [
           "Suspenseful",
           "Gritty",
           "Dark"
        ],
        "typeOfHoliday": [
           "Adventure Holiday",
           "City Break"
        ],
        "visitType": "City",
        "activities": "127",
        "hotels": 40,
        "restaurants": "11,406",
        "topRestaurants": "Club A Steakhouse",
        "placeToVisit": "Belvedere Estate, Brooklyn",
        "male": {
           "under18": "70",
           "18-29": 79,
           "30-44": 78,
           "45Plus": 78
        },
        "female": {
           "under18": "60",
           "18-29": 81,
           "30-44": 80,
           "45Plus": 80
        },
        "other": {
           "under18": "65",
           "18-29": 80,
           "30-44": 79,
           "45Plus": 79
        }
     },
      {
        "cityOrCountry": "Denver",
        "country": "Colorado, USA",
        "seasonRating": {
           "spring": 23,
           "summer": 33,
           "fall": 14,
           "winter": 8
        },
        "monthsToVisit": [
           "April",
           "May",





        ],
        "season": [
           "Summer",


        ],
        "show": "The Social Dilemma",
        "typeOfShow": "Documentary",
        "rating": 7.6,
        "genre": [
           "Documentary",
           "Drama",

        ],
        "feeling": [
           "Provocative",
           "Investigative",

        ],
        "typeOfHoliday": [
           "City Break",
           "Adventure Holiday"
        ],
        "visitType": "State",
        "activities": "59",
        "hotels": 7,
        "restaurants": "2,698",
        "topRestaurants": "Corinne",
        "placeToVisit": "Mass FX Media",
        "male": {
           "under18": "76",
           "18-29": 73,
           "30-44": 77,
           "45Plus": 75
        },
        "female": {
           "under18": "77",
           "18-29": 72,
           "30-44": 76,
           "45Plus": 76
        },
        "other": {
           "under18": "76.5",
           "18-29": 72.5,
           "30-44": 76.5,
           "45Plus": 75.5
        }
     },
      {
        "cityOrCountry": "New York City",
        "country": "New York, USA",
        "seasonRating": {
           "spring": 22,
           "summer": 29,
           "fall": 18,
           "winter": 4
        },
        "monthsToVisit": [
           "April",
           "June",





        ],
        "season": [
           "Summer",


        ],
        "show": "The Sons of Sam: A Descent into Darkness",
        "typeOfShow": "Series",
        "rating": 7,
        "genre": [
           "Documentary",
           "Crime",
           "History"
        ],
        "feeling": [
           "Ominous",
           "Gritty",
           "Scary"
        ],
        "typeOfHoliday": [
           "Adventure Holiday",
           "City Break"
        ],
        "visitType": "City",
        "activities": "127",
        "hotels": 40,
        "restaurants": "11,406",
        "topRestaurants": "Club A Steakhouse",
        "placeToVisit": "",
        "male": {
           "under18": "60",
           "18-29": 73,
           "30-44": 70,
           "45Plus": 70
        },
        "female": {
           "under18": "71",
           "18-29": 55,
           "30-44": 68,
           "45Plus": 69
        },
        "other": {
           "under18": "65.5",
           "18-29": 64,
           "30-44": 69,
           "45Plus": 69.5
        }
     },
      {
        "cityOrCountry": "New York City",
        "country": "New York, USA",
        "seasonRating": {
           "spring": 22,
           "summer": 29,
           "fall": 18,
           "winter": 4
        },
        "monthsToVisit": [
           "April",
           "June",





        ],
        "season": [
           "Summer",


        ],
        "show": "The Umbrella Academy",
        "typeOfShow": "Series",
        "rating": 8,
        "genre": [
           "Action",
           "Adventure",
           "Comedy"
        ],
        "feeling": [
           "Mind-bending",
           "Quirky",

        ],
        "typeOfHoliday": [
           "Adventure Holiday",
           "City Break"
        ],
        "visitType": "City",
        "activities": "127",
        "hotels": 40,
        "restaurants": "11,406",
        "topRestaurants": "Club A Steakhouse",
        "placeToVisit": "",
        "male": {
           "under18": "79",
           "18-29": 82,
           "30-44": 79,
           "45Plus": 78
        },
        "female": {
           "under18": "82",
           "18-29": 82,
           "30-44": 82,
           "45Plus": 82
        },
        "other": {
           "under18": "80.5",
           "18-29": 82,
           "30-44": 80.5,
           "45Plus": 80
        }
     },
      {
        "cityOrCountry": "Delhi",
        "country": "India",
        "seasonRating": {
           "spring": 32,
           "summer": 41,
           "fall": 25,
           "winter": 10
        },
        "monthsToVisit": [
           "December",
           "January",
           "February",
           "March",



        ],
        "season": [
           "Winter",
           "Spring",

        ],
        "show": "The White Tiger",
        "typeOfShow": "Movie",
        "rating": 7.1,
        "genre": [
           "Crime",
           "Drama",

        ],
        "feeling": [
           "Provocative",
           "Gritty",
           "Inspiring"
        ],
        "typeOfHoliday": [
           "City Break",
           "Adventure Holiday"
        ],
        "visitType": "City",
        "activities": "2,000",
        "hotels": 903,
        "restaurants": "13,871",
        "topRestaurants": "Manuhaar- The Taste of Tradition",
        "placeToVisit": "",
        "male": {
           "under18": "71",
           "18-29": 74,
           "30-44": 72,
           "45Plus": 71
        },
        "female": {
           "under18": "72",
           "18-29": 47,
           "30-44": 72,
           "45Plus": 71
        },
        "other": {
           "under18": "71.5",
           "18-29": 60.5,
           "30-44": 72,
           "45Plus": 71
        }
     },
      {
        "cityOrCountry": "New York City",
        "country": "New York, USA",
        "seasonRating": {
           "spring": 22,
           "summer": 29,
           "fall": 18,
           "winter": 4
        },
        "monthsToVisit": [
           "April",
           "May",
           "June",




        ],
        "season": [
           "Summer",


        ],
        "show": "tick…tick…BOOM!",
        "typeOfShow": "Movie",
        "rating": 7.6,
        "genre": [
           "Drama",
           "Music",
           "Biography"
        ],
        "feeling": [
           "Emotional",
           "Inspiring",
           "Heartfelt"
        ],
        "typeOfHoliday": [
           "Adventure Holiday",
           "City Break"
        ],
        "visitType": "City",
        "activities": "127",
        "hotels": 40,
        "restaurants": "11,406",
        "topRestaurants": "Club A Steakhouse",
        "placeToVisit": "508 Greenwich Street in Soho (Apartment lived in)",
        "male": {
           "under18": "80",
           "18-29": 76,
           "30-44": 74,
           "45Plus": 74
        },
        "female": {
           "under18": "82",
           "18-29": 78,
           "30-44": 77,
           "45Plus": 79
        },
        "other": {
           "under18": "81",
           "18-29": 77,
           "30-44": 75.5,
           "45Plus": 76.5
        }
     },
      {
        "cityOrCountry": "Wynnewood",
        "country": "Oklahoma, USA",
        "seasonRating": {
           "spring": 23,
           "summer": 35,
           "fall": 19,
           "winter": 11
        },
        "monthsToVisit": [
           "June",
           "July",
           "August",
           "September",



        ],
        "season": [
           "Summer",
           "Autumn",

        ],
        "show": "Tiger King: Murder, Mayhem and Madness",
        "typeOfShow": "Movie",
        "rating": 7.5,
        "genre": [
           "Documentary",
           "Crime",
           "Comedy"
        ],
        "feeling": [
           "Provocative",
           "Investigative",

        ],
        "typeOfHoliday": [
           "Adventure Holiday",
           "Remote"
        ],
        "visitType": "State",
        "activities": "1",
        "hotels": 1,
        "restaurants": "1,172",
        "topRestaurants": "Sang Kee Asian Bistro",
        "placeToVisit": "big cat rescue",
        "male": {
           "under18": "76",
           "18-29": 78,
           "30-44": 76,
           "45Plus": 76
        },
        "female": {
           "under18": "74",
           "18-29": 68,
           "30-44": 75,
           "45Plus": 74
        },
        "other": {
           "under18": "75",
           "18-29": 73,
           "30-44": 75.5,
           "45Plus": 75
        }
     },
      {
        "cityOrCountry": "Los Angeles",
        "country": "California, USA",
        "seasonRating": {
           "spring": 24,
           "summer": 29,
           "fall": 23,
           "winter": 21
        },
        "monthsToVisit": [
           "March",
           "April",
           "May",




        ],
        "season": [
           "Spring",


        ],
        "show": "Unbelievable",
        "typeOfShow": "Series",
        "rating": 8.4,
        "genre": [
           "Crime",
           "Drama",
           "Thriller"
        ],
        "feeling": [
           "Emotional",
           "Suspenseful",
           "Heartfelt"
        ],
        "typeOfHoliday": [
           "City Break",
           "Beach Holiday"
        ],
        "visitType": "State",
        "activities": "19",
        "hotels": 20,
        "restaurants": "13,365",
        "topRestaurants": "n,naka",
        "placeToVisit": "",
        "male": {
           "under18": "83",
           "18-29": 79,
           "30-44": 83,
           "45Plus": 82
        },
        "female": {
           "under18": "86",
           "18-29": 81,
           "30-44": 86,
           "45Plus": 85
        },
        "other": {
           "under18": "84.5",
           "18-29": 80,
           "30-44": 84.5,
           "45Plus": 83.5
        }
     },
      {
        "cityOrCountry": "New York City",
        "country": "New York, USA",
        "seasonRating": {
           "spring": 22,
           "summer": 29,
           "fall": 18,
           "winter": 4
        },
        "monthsToVisit": [
           "April",
           "June",





        ],
        "season": [
           "Summer",


        ],
        "show": "When They See Us",
        "typeOfShow": "Series",
        "rating": 8.9,
        "genre": [
           "Biography",
           "Drama",
           "Crime"
        ],
        "feeling": [
           "Provocative",
           "Emotional",

        ],
        "typeOfHoliday": [
           "Adventure Holiday",
           "City Break"
        ],
        "visitType": "City",
        "activities": "127",
        "hotels": 40,
        "restaurants": "11,406",
        "topRestaurants": "Club A Steakhouse",
        "placeToVisit": "",
        "male": {
           "under18": "88",
           "18-29": 90,
           "30-44": 90,
           "45Plus": 88
        },
        "female": {
           "under18": "91",
           "18-29": 81,
           "30-44": 92,
           "45Plus": 90
        },
        "other": {
           "under18": "89.5",
           "18-29": 85.5,
           "30-44": 91,
           "45Plus": 89
        }
     },
      {
        "cityOrCountry": "New York City",
        "country": "New York, USA",
        "seasonRating": {
           "spring": 22,
           "summer": 29,
           "fall": 18,
           "winter": 4
        },
        "monthsToVisit": [
           "April",
           "June",





        ],
        "season": [
           "Summer",


        ],
        "show": "You",
        "typeOfShow": "Series",
        "rating": 7.7,
        "genre": [
           "Crime",
           "Thriller",
           "Romance"
        ],
        "feeling": [
           "Dark",
           "Suspenseful",
           "Romantic"
        ],
        "typeOfHoliday": [
           "Couples Holiday",
           "City Break"
        ],
        "visitType": "Town",
        "activities": "127",
        "hotels": 40,
        "restaurants": "11,406",
        "topRestaurants": "Club A Steakhouse",
        "placeToVisit": "",
        "male": {
           "under18": "77",
           "18-29": 82,
           "30-44": 79,
           "45Plus": 76
        },
        "female": {
           "under18": "77",
           "18-29": 75,
           "30-44": 77,
           "45Plus": 77
        },
        "other": {
           "under18": "77",
           "18-29": 78.5,
           "30-44": 78,
           "45Plus": 76.5
        }
     }
   ],
   locations: [{
         "location": "tokyo",
         "desc": "Visit the neon lights and skyscrapers of Tokyo for a truly unique vacation. There’s no shortage of things to do in the metropolis, so whether you’re going with family, friends or solo, you’ll be spoilt for choice."
      },
      {
         "location": "san-francisco",
         "desc": 'Sunny San Francisco is a great place for your next vacation. With the iconic Golden Gate bridge, mysterious Alcatraz and the ‘Crookedest Street in the World’ in the city’s midst, a vacation here is something you shouldn’t miss. And if you’re moving here, MyBaggage can <a href="https://www.mybaggage.com/shipping/us/international-removals/how-to-move-to-america/california/">ship your bags</a> to you with ease.'
      },
      {
         "location": "frederick",
         "desc": 'The small town of Frederick would make a perfect vacation if you’re looking for an understated, quiet trip to get away from it all. You can even get your <a href="https://www.mybaggage.com/shipping/us/">bags shipped directly to you</a> there if you fall in love with the place and decide to never leave. Who knows, if you get talking to some of the residents, you might even uncover some dark secrets…'
      },
      {
         "location": "oceanside",
         "desc": 'This stunning city makes for the perfect beachy vacation. From the palm tree filled Harbor Beach to the marina and pier, Oceanside has plenty to offer visitors. And, if you’re more than a visitor and want to move there for a longer period, <a href="https://www.mybaggage.com/shipping/us/international-removals/how-to-move-to-america/california/">MyBaggage can get your belongings to you</a> in a heartbeat.'
      },
      {
         "location": "santa-clarita",
         "desc": 'Santa Clarita is the perfect destination for any adrenaline junkies out there, being the home of the famous Six Flags Magic Mountain theme park. If this isn’t up your street, the area also has some stunning natural rock formations and scenery - there’s really something for everyone. For longer stays, <a href="https://www.mybaggage.com/shipping/us/international-removals/how-to-move-to-america/california/">get your baggage sent to you</a> with MyBaggage’s highly-rated service.'
      },
      {
         "location": "london",
         "desc": 'The UK capital is a great location for any vacation. There are countless things to see and do all over the city, including a huge number of award-winning museums to visit if, or when, the weather turns rainy. Struggling to fit all your London outfits in your suitcase? <a href="https://www.mybaggage.com/shipping/us/international-removals/moving-to-uk/">MyBaggage can ship them to you</a> to make sure you have everything you need.'
      },
      {
         "location": "albuquerque",
         "desc": 'Albuquerque is known as the cultural centre of the American Southwest, so it’s the perfect place for a relaxing vacation. Located in the high desert of New Mexico, the city is full of old buildings and native American history. Moving to Albuquerque rather than visiting? <a href="https://www.mybaggage.com/shipping/us/">MyBaggage can ship your belongings to wherever you are in the USA</a>.'
      },
      {
         "location": "bath",
         "desc": 'Bath, England is completely full of rich history, beautiful buildings and the eponymous Roman baths. Vacationing here will give tourists a serene experience, with plenty of time to explore the stunning city and see everything Bath has to offer. Want a more permanent change of scene? <a href="https://www.mybaggage.com/shipping/us/international-removals/moving-to-uk/">Have all your things shipped directly to you</a> with MyBaggage.'
      },
      {
         "location": "melbourne",
         "desc": 'Melbourne is quickly becoming one of the most up-and-coming cities in the world, with more bars and restaurants than you’d ever be able to visit on a week’s vacation. Don’t let this stop you, though, as the sights to see in Melbourne are not to be missed. Need more time to enjoy everything the city has to offer? <a href="https://www.mybaggage.com/shipping/us/international-removals/moving-to-australia/">Have your luggage shipped to you by MyBaggage</a>.'
      },
      {
         "location": "los-angeles",
         "desc": 'Hollywood Boulevard. Universal Studios. Rodeo Drive. Los Angeles has become an iconic vacation destination. There are countless activities to do, from celeb spotting to hiking to the Hollywood sign, so your vacation itinerary is bound to fill up quickly. If you want to stay longer, or permanently, MyBaggage can <a href="https://www.mybaggage.com/shipping/us/international-removals/how-to-move-to-america/california/">ship your belongings</a> to you, fast.'
      },
      {
         "location": "california",
         "desc": 'The Golden State is a stunning place to visit, with cities offering all types of vacations to suit any person. From the bright lights of Hollywood to the relaxing wine tours of Napa Valley, you’ll be able to soak up the Californian sun in whatever capacity you want. Make the state your permanent home, if you want, and have MyBaggage <a href="https://www.mybaggage.com/shipping/us/">ship your belongings to your door</a> in no time.'
      },
      {
         "location": "mexico",
         "desc": "There are so many incredible destinations in Mexico, including the incredibly popular Mexico City and Oaxaca. A vacation there is bound to be full of culture, fun and great food, so it’s the perfect place to visit with your friends and family."
      },
      {
         "location": "new-york-city",
         "desc": 'The Big Apple itself is a haven for tourists, with activities available 24/7. Take a trip to Broadway for a show, or go on a leisurely stroll around the MET. No matter what you decide to do, it’s bound to be a great trip. For anyone who thinks New York could be more than just a holiday, MyBaggage will <a href="https://www.mybaggage.com/shipping/us/international-removals/how-to-move-to-america/new-york/">get your belongings to you quickly</a>.'
      },
      {
         "location": "laguna-beach",
         "desc": 'If you’re a fan of a beach vacation, Laguna Beach is perfect. The city is known for its coves and beaches, as the name suggests, but also for its art galleries and gardens. As a result, you can either spend a day lounging on the sand, or take a leisurely stroll around some great attractions. The opportunities are endless. If you love the area enough to stay more permanently, <a href="https://www.mybaggage.com/shipping/us/">MyBaggage can get your belongings to you</a> very quickly.'
      },
      {
         "location": "madrid",
         "desc": 'A Spanish vacation is never better than in Madrid. The city houses elegant boulevards, beautiful parks and a huge collection of iconic European artwork. It’s the perfect destination for anyone who appreciates the finer things in life. If you decide you need to stay in Madrid longer to take everything in, MyBaggage can <a href="https://www.mybaggage.com/shipping/us/international-removals/moving-to-spain/">deliver everything you need from home</a>, fast.'
      },
      {
         "location": "paris",
         "desc": 'The City of Love is an extremely popular vacation destination for a reason. From luxury shopping on the Champs Élysées to packed underground raves, Paris has something for every type of tourist. If the Paris fever takes you, and you decide you want to stay even longer, you can <a href="https://www.mybaggage.com/shipping/us/international-removals/moving-to-france/">get your belongings sent to you</a> with MyBaggage before you can say ‘bonjour’.'
      },
      {
         "location": "dhaka",
         "desc": "The capital of Bangladesh is rich with diversity, great cuisine, art festivals and historic buildings. The city dates back to the 17th-century, and has over 2000 buildings from the Mughal and British period in its area. Tourists will love the vast history and dramatic architecture here - it’s something not to be missed."
      },
      {
         "location": "county-wicklow",
         "desc": 'In the east of Ireland lies this stunning area, containing mountains, glacial lakes and even the remains of an early Monastic settlement. It’s a truly magical place, bound to make any tourist feel like the main character. If the wonder of County Wicklow makes you want to stay longer, or even permanently, MyBaggage can <a href="https://www.mybaggage.com/shipping/us/international-removals/moving-to-ireland/">ship your belongings</a> straight to your door.'
      },
      {
         "location": "boston",
         "desc": 'Boston is a thriving city full of culture and activities for all types of tourists. Whether you want to visit one of the city’s highly rated museums or follow the Freedom Trail to see the historic sites, a vacation here will be one you’ll never forget. If, after your trip, you want to call Boston home, MyBaggage can take the pain out of moving by <a href="https://www.mybaggage.com/shipping/us/">sending your belongings directly to you</a>.'
      },
      {
         "location": "seattle",
         "desc": 'Home of the Space Needle, Pike Place market and Macklemore, Seattle is an exciting city that’s full of life. Tourists will have no shortage of sights to see and activities to do, making it the perfect spot for a vacation of any length. Want to extend your trip even longer? MyBaggage can <a href="https://www.mybaggage.com/shipping/us/">get any extra belongings shipped to you</a> at a moment’s notice.'
      },
      {
         "location": "exuma",
         "desc": "Home to the Bahamas’ famous swimming pigs, Exuma is a picture perfect vacation destination. When staying here, you’ll have endless time to soak up the sun and relax - you’ll return home a completely new person."
      },
      {
         "location": "cobourg",
         "desc": 'In Ontario, Canada, lies this charming lakeside town. Perfect for a quiet, relaxing vacation, it’s rich in history and heritage, with stunning architecture, a beautiful marina and boardwalk and scenic nature trails to explore. When you are inevitably charmed by this town and decide you might never leave, <a href="https://www.mybaggage.com/shipping/us/international-removals/moving-to-canada/">your belongings can be shipped to you</a> in no time with MyBaggage.'
      },
      {
         "location": "san-fernando-valley",
         "desc": 'San Fernando Valley, including the northern half of Los Angeles and various other cities, is full of beautiful sights and exciting activities. The area has a much slower pace than LA, so it’s perfect for those who want to vacation somewhere with a more relaxed atmosphere. If you want to join the likes of Will Smith and George Clooney living in the area, <a href="https://www.mybaggage.com/shipping/us/">get your belongings shipped to you</a> quickly with MyBaggage.'
      },
      {
         "location": "santa-fe",
         "desc": 'The city of Santa Fe is renowned for the unique architecture and creative arts hub it houses. The city has so much history, having been originally founded in 1610, so it is the perfect destination for a cultural vacation. If you want to make the crooked streets your home after visiting, we don’t blame you. <a href="https://www.mybaggage.com/shipping/us/">Get your belongings sent to you</a> with MyBaggage.'
      },
      {
         "location": "baltimore",
         "desc": 'The city of Baltimore houses an important seaport, as well as a huge number of independent bars and restaurants for visitors. You can also see the National Aquarium and the Civil War-era warship in the harbor. And for the full Baltimore experience, make sure to eat some locally sourced crab at some point. Want to stay longer? More of your <a href="https://www.mybaggage.com/shipping/us/">belongings can be shipped to you</a> by MyBaggage.'
      },
      {
         "location": "greater-victoria",
         "desc": 'The British colonial history of this area has left behind a large number of beautiful Victorian buildings, making it a stunning vacation destination. Butchart Gardens also has some stunning floral displays, so it’s a truly insta-worthy area. If you fall in love with the area and decide you want to stay more permanently, <a href="https://www.mybaggage.com/shipping/us/international-removals/moving-to-canada/">MyBaggage can ship your things to you</a> very quickly.'
      },
      {
         "location": "vancouver",
         "desc": 'Vancouver has a thriving art, theatre and music scene, making it one of the most exciting places to vacation. Whether you’re on a fun weekend trip with friends or want to solo travel to meet the countless other tourists in the city, there will never be a dull moment in Vancouver. Want to make the city your home? <a href="https://www.mybaggage.com/shipping/us/international-removals/moving-to-canada/">MyBaggage will ship your belongings</a> straight to your door.'
      },
      {
         "location": "pittsburgh",
         "desc": 'If you love museums, Pittsburgh is a great place to go. From the Andy Warhol Museum to the Carnegie Museum of Art, you’ll leave Pittsburgh with much more knowledge than you came with. The city also houses some impressive buildings and 446 bridges, so there’s no lack of things to see here. If the city charms you enough to want to move there, <a href="https://www.mybaggage.com/shipping/us/">MyBaggage will ship everything to your door</a>.'
      },
      {
         "location": "colombia",
         "desc": "Colombia is full of joy and diversity, with a thriving music and cultural scene, as well as stunning natural sights. Bogotá, Cali, Cartagena de Indias: the vast, varied and beautiful cities you could visit are waiting for you as we speak."
      },
      {
         "location": "sherman-oaks",
         "desc": 'This Los Angeles suburb is full of charm, with slick malls, gastropubs and bars aplenty. A visit to Sherman Oaks is a great option for a short, fun-filled vacation, allowing you to soak in the Californian sun while enjoying everything the neighborhood has to offer. Want to make Sherman Oaks your permanent home? <a href="https://www.mybaggage.com/shipping/us/international-removals/how-to-move-to-america/california/">MyBaggage will ship everything you need</a> straight to your door.'
      },
      {
         "location": "charleston",
         "desc": 'This historical city is defined by its historic cobbled streets, horse-drawn carriages and charming pastel houses from the antebellum period. It’s full of history and culture, so makes for the perfect vacation if you’re after something different. If Charleston charms you, and you want to make it a more permanent home, MyBaggage can <a href="https://www.mybaggage.com/shipping/us/">get your belongings from your old home to here</a>, fast.'
      },
      {
         "location": "lake-of-the-ozarks",
         "desc": 'This beautiful reservoir has more shoreline than the coast of California, so there’s no shortage of space to enjoy the stunning sights. From thrilling water sports to relaxing fishing, the area offers tons of activities for all types of tourists. If the lake wins your heart enough to want to move to the area, <a href="https://www.mybaggage.com/shipping/us/">MyBaggage can get your belongings to you</a> in no time.'
      },
      {
         "location": "kansas-city",
         "desc": 'If you’re a fan of barbeque and jazz, look no further than Kansas City. The city houses the American Jazz Museum as well as many other highly-rated museums, and you can see plenty of sights all over, including the famous fountains. Want to move there more permanently? <a href="https://www.mybaggage.com/shipping/us/">Get your belongings sent over</a> to Missouri with MyBaggage.'
      },
      {
         "location": "georgia",
         "desc": 'The state of Georgia has so much to offer. Its terrain spans beautiful coastal beaches, impressive mountains and vast farmland. The city of Atlanta is also in this state, offering countless attractions for tourists. There’s truly something for everyone here. Is the state somewhere you want to stay more permanently? <a href="https://www.mybaggage.com/shipping/us/">MyBaggage will get your belongings to you</a>, fast.'
      },
      {
         "location": "monterey",
         "desc": 'Home of the famous Monterey Bay Aquarium as well as Cannery Row - a place immortalized by John Steinbeck in his novel written about it - Monterey is full of culture and exciting activities. There are plenty of gift shops, restaurants and bars in unique buildings, so it’s great for tourists. Want to stay longer? <a href="https://www.mybaggage.com/shipping/us/">MyBaggage can ship more belongings to you</a> in no time at all.'
      },
      {
         "location": "harlem",
         "desc": 'The New York neighborhood of Harlem is known all over for its intimate jazz clubs, soul food restaurants and rich African-American heritage. The nightlife in the area is not to be missed, and in the day you can enjoy the trendy food places and trendy bars that make up the area. Want to make the move to Harlem more permanently, <a href="https://www.mybaggage.com/shipping/us/">MyBaggage can get everything you need to you</a> in no time.'
      },
      {
         "location": "ontario",
         "desc": 'Ontario is a stunning area to vacation in. There’s a huge amount of diversity when it comes to the food, languages and cultures in Ontario. From the city of Ottawa to the natural wonders and nature trails of the more remote areas, you’re bound to find something you love here. Want to make the move more permanent? MyBaggage can <a href="https://www.mybaggage.com/shipping/us/international-removals/moving-to-canada/">easily ship your belongings to you</a>.'
      },
      {
         "location": "baja-california",
         "desc": "The Mexican state of Baja California is the home to expanses of stunning coastline and exciting cities and towns. Tijuana, famous for its nightlife and shopping opportunities, is visited by hundreds of thousands of tourists each year. Rosarito is full of wide, Pacific beaches with miles of sand for you to soak up the sun on."
      },
      {
         "location": "wye-valley",
         "desc": 'The stunning Wye Valley is a designated Area of Outstanding Natural Beauty, so you can be guaranteed some amazing views if you visit. The area straddles the English and Welsh border, and is full of amazing walks, romantic ruins and charming pubs. You can even hire a canoe for a day on the River Wye. Want to make this area your home? <a href="https://www.mybaggage.com/shipping/us/international-removals/moving-to-uk/">MyBaggage can ship your belongings overseas to you</a>.'
      },
      {
         "location": "budapest",
         "desc": "Budapest has some of the most iconic nightlife venues in the world, with the ruin bars drawing countless tourists every year. The cultural sights are also incredible, with old buildings and historical baths to also put into your itinerary. From the Old Town to the frequent boat tours, you’ll want to soak in every aspect of this city."
      },
      {
         "location": "incheon",
         "desc": "The South Korean city of Incheon is a bustling, ultramodern area to visit. A vacation here will never be dull, with exciting boat tours and beach-lined islands easily reachable from the mainland. There’s even a park modelled after New York’s Central Park, Songdo Central Park, so there’s plenty of green space among the high rise buildings."
      },
      {
         "location": "atlanta",
         "desc": 'Atlanta is full of history, being a center in both the Civil War and the Civil Right Movement of the 1960s. There are various museums in the city documenting the role it played in these moments in history, containing important knowledge that isn’t to be missed by visitors. The city is also beautiful to walk around, so if museums aren’t your thing there’s plenty more to do. Is Atlanta your future home? <a href="https://www.mybaggage.com/shipping/us/">MyBaggage can ship your belongings to you</a> in a flash.'
      },
      {
         "location": "auckland",
         "desc": 'The city of Auckland in New Zealand is a truly beautiful place to visit. From the iconic Sky Tower with views you’ll never forget, to the city’s oldest park, Auckland Domain, visitors will never struggle to find something exciting to see in the city. If New Zealand captures your heart enough to want to move there, <a href="https://www.mybaggage.com/shipping/us/international-removals/moving-to-new-zealand/">MyBaggage can get your belongings to you</a>.'
      },
      {
         "location": "hollywood",
         "desc": 'Hollywood is the home of classic entertainment, with landmarks like the Hollywood sign and the Walk of Fame drawing millions of visitors every year. At night, you can enjoy improv comedy clubs, retro bars and exciting nightclubs, and by day you can explore the stunning Hollywood hills that surround the area. Want to live here? MyBaggage can <a href="https://www.mybaggage.com/shipping/us/">ship everything you need right to your door</a>.'
      },
      {
         "location": "chicago",
         "desc": 'Whether you want to enjoy one of their iconic pizzas or take a trip to The Bean, Chicago has it all. The city has extremely bold architecture and is renowned for its museums, including the Art Institute of Chicago. If you can’t see everything you want to see just visiting for vacation, stay more permanently and have MyBaggage <a href="https://www.mybaggage.com/shipping/us/">ship you your belongings</a> easily.'
      },
      {
         "location": "berlin",
         "desc": "The industrial, exciting city of Berlin is full of both history and culture. It’s famous for its nightlife, with iconic nightclubs like Berghain bringing hours-long lines every night, and areas of notable historic events, such as the Berlin Wall and Holocaust Museum. By day, you can explore the stunning city and learn something new, and by night, you can dance to German techno in one of many underground clubs. Sounds like a perfect vacation to us."
      },
      {
         "location": "denver",
         "desc": 'Denver is a bustling metropolis dating back to the Old West era, so there’s plenty of history to be seen in the area. From stunning buildings in the city to the Rocky Mountains nearby, all kinds of tourists will love what Denver has to offer. Want to make Denver your permanent home? <a href="https://www.mybaggage.com/shipping/us/">MyBaggage can get your belongings to you</a> in no time.'
      },
      {
         "location": "india",
         "desc": "India has a huge amount to offer as a vacation destination. The Taj Mahal, The Golden City, The Red Fort: you could spend months on end in this country and still not run out of things to do and see. Enjoy the diverse and rich culture of the country, eat the amazing food on offer in every city, and see the beautiful sights all over. You won’t want to leave."
      },
      {
         "location": "wynnewood",
         "desc": 'Wynnewood, Oklahoma offers plenty to tourists. The nature trails are truly beautiful, and the various parks are great to wind down in. If you want a vacation where you can truly relax and experience something different, then this is the place to go. Want to make Wynnewood your permanent home? MyBaggage can <a href="https://www.mybaggage.com/shipping/us/">ship all your belongings to you</a> in no time.'
      },
      {
         "location": "seoul",
         "desc": "Seoul mixes modern architecture and technology with historical buildings and cultural landmarks like no other place. The neon lights and bustling metropolis is extremely exciting to explore, including the futuristic Dongdaemun Design Plaza. In contrast, the Jogyesa Temple is a site of historic importance, with ancient locusts living there and stunning pine trees scattered around the area. Make sure you see both sides of the city."
      },
      {
         "location": "spetses",
         "desc": 'The island of Spetses in Greece is a stunning haven, with bars and restaurants aplenty, and beautiful scenery to take in. Visit Bekiri Cave for some natural wonder, or visit the Bouboulina Museum to learn about the heroine of the Greek War of Independence in 1821 - there are so many options for visitors. If you fall in love with the island enough to never leave, <a href="https://www.mybaggage.com/shipping/luggage-to-greece/">MyBaggage can ship your belongings</a> straight to your island-home door.'
      },
      {
         "location": "surrey",
         "desc": 'The rolling hills of the English countryside are stunning in Surrey, an Area of Outstanding Natural Beauty. It’s so beautiful, in fact, that it inspired some of the most influential writers of all time, including Jane Austen and Arthur Conan Doyle. If you end up feeling the pull of this English county and decide to stay more permanently, MyBaggage will <a href="https://www.mybaggage.com/shipping/us/international-removals/moving-to-uk/">send your belongings to you</a> in no time.'
      },
      {
         "location": "queenstown",
         "desc": 'Queenstown is the perfect destination for any adrenaline junkies. With a huge choice of activities on offer in the town, from bungee jumping to white water rafting, you will never be bored on a vacation here. Extreme sports not your thing? The town is set at the foot of the stunning Southern Alps, so there’s more than enough to see without having to jump out of a plane. And if New Zealand looks more like a forever home, <a href="https://www.mybaggage.com/shipping/international-removals/moving-to-new-zealand/">MyBaggage can send your belongings</a> all the way to you.'
      },
      {
         "location": "forest-of-dean",
         "desc": 'If you want a vacation spot filled with history and beauty, the Forest of Dean in Gloucestershire, England might just be perfect. The forest dates back to the Medieval era, and was used in Tudor times as a hunting ground, so there is history dripping out of the scenery in this area. If you want the forest to be much closer to home, then <a href="https://www.mybaggage.com/shipping/us/international-removals/moving-to-uk/">move there permanently</a> and have MyBaggage ship your belongings to you.'
      }
   ],
   showInfo: [{
         "show": "Alice In Borderland",
         "desc": "Visit the IRL Shibuya Crossing to get a full taste of Alice in Borderland, a gritty show about an obsessed gamer, who finds himself in a strange version of Tokyo where he and his friends must compete in games to survive."
      },
      {
         "show": "Always Be My Maybe",
         "desc": "This heartwarming rom-com follows a pair of childhood sweethearts, who reconnect 15 years later as adults. Yes, it’s as cute as it sounds. Yes, there are some classic rom-com tropes that we fall for every single time. Yes, we cried at the end."
      },
      {
         "show": "American Murder: The Family Next Door",
         "desc": "This documentary shows the events leading to the disappearance of Shanann Watts and her two children, as well as the nightmarish events that followed. It’s not a fun watch, but it’s definitely fascinating."
      },
      {
         "show": "American Vandal",
         "desc": "A satire of the classic true-crime genre, this show takes a look at the aftermath of some *very* serious high school pranks. From phallic car vandalism to laxative lemonade, you’ve never seen an investigation like this."
      },
      {
         "show": "Atypical",
         "desc": "This heartfelt comedy shows the life of a teenager on the autism spectrum as he goes on a journey to find romance. With a focus on family, love and acceptance, this show is a perfect example of why being ‘normal’ is overrated. Visit the Aquarium of the Pacific to see a location shown on screen!"
      },
      {
         "show": "Behind Her Eyes",
         "desc": "If you like a mind-bending thriller, this show is perfect for you. It follows a single mother who, after beginning an affair with her psychiatrist boss, finds herself in a world full of mind-games and a web of secrets."
      },
      {
         "show": "Better Call Saul",
         "desc": "This Breaking Bad spin-off follows an ex-con artist who makes a career pivot into a small-time attorney. Cue: a series of events wrapped in tragedy, trials and moral challenges. You can even visit the real-life version of Los Pollos Hermanos in Albuquerque, called Twisters."
      },
      {
         "show": "Bird Box",
         "desc": "If you see it, you die. That’s the general idea of Bird Box, following a mother and her children as they travel down the Smith River (a real place you can visit, by the way) to find a safe place to hide. It’s a true thrill ride."
      },
      {
         "show": "Breaking Bad",
         "desc": "This show follows a Chemistry teacher who goes into the meth-making business to pay for his medical bills, and the school in which he teaches is actually a real place you can visit. Rio Rancho High School is the set of Walter White’s place of employment, J. P. Wynne High School."
      },
      {
         "show": "Bridgerton",
         "desc": "This steamy period drama isn’t something to watch with your mom. It follows the Bridgerton family and the ‘ton’ they live in, as they try to find love and navigate their position in society. Want to visit the set where some of it took place? The Bridgerton House garden scenes were filmed at The Historic Dockyard Chatham."
      },
      {
         "show": "Clickbait",
         "desc": "This intense drama follows the friends and family of Nick Brewer uncover who is behind his abduction - which includes a sinister online detail. Want to see some of the places featured in the show IRL? The Oakland Bay Bridge is one real life area used in the show."
      },
      {
         "show": "Cobra Kai",
         "desc": "An action packed comedy-drama, Cobra Kai is a sequel to the original Karate Kid films. The show follows one of the characters from the films reopening the infamous Cobra Kai dojo, reigniting old rivalries and bringing together a whole new cast of characters."
      },
      {
         "show": "Community",
         "desc": "Now a cult classic sitcom, Community follows the relationships between a diverse group of community college students brought together by a study group. From an ex-lawyer to a divorced mother, the quirky group’s antics inevitably lead to hilarity."
      },
      {
         "show": "Control Z",
         "desc": "This Spanish show follows Sofía, an observant high school student, working to uncover the identity of a hacker who has begun to release students’ secrets to the entire school. It’s full of suspense, making it a completely binge-worthy show."
      },
      {
         "show": "Daredevil",
         "desc": "This exciting Marvel show follows Matt Murdock, a man who has been blind since childhood, overcoming the challenges he’s faced with and fighting crime in New York City - both as a lawyer in his day job, and by night as Daredevil."
      },
      {
         "show": "Daughter From Another Mother",
         "desc": "After two women realize that their babies were switched at birth, they devise a plan to combine their families, creating a new life and leading to some hilarious - and heartwarming - moments. With only 17 episodes, it’s a great weekend binge watch."
      },
      {
         "show": "Dead To Me",
         "desc": "A show about unlikely friends with a crime drama twist, Dead to Me follows the relationships between Jen and Judy and the secret that could drive them apart. The Coretta Cafe shown in one episode exists in real life, too, as the Malibu Farm Restaurant - and it’s just as nice as it looks on screen."
      },
      {
         "show": "El Camino: A Breaking Bad Movie",
         "desc": "Continuing the story of Jesse Pinkman, Walter White’s partner-in-crime (literally), El Camino shows the character after a dramatic escape from captivity. On the run from the police, Jesse must confront his past and focus on his future. His parents’ house is available to visit IRL, sitting at 501 11th Street NW, Albuquerque."
      },
      {
         "show": "Elite",
         "desc": "A thrilling teen drama, Elite follows the lives of three working-class teens who are enrolled into an exclusive private school. The differences between them and the wealthy students of the school lead, eventually, to murder. It’s a real rollercoaster."
      },
      {
         "show": "Emily In Paris",
         "desc": "What happens when a quintessentially American marketer gets thrown in the deep end in Paris? This show finds out, leading to both hilarious and heartwarming moments. Emily’s fictional Parisian office is located in a real place, the Place de Valois, which you can visit to live out your French fantasies."
      },
      {
         "show": "Extraction",
         "desc": "This action thriller follows an Australian covert soldier on his mission to rescue the kidnapped son of an Indian drug lord, but when he is double-crossed, the mission goes more than a little awry. It’s jam packed with suspense, fights and high stakes. What’s not to like?"
      },
      {
         "show": "Fate: The Winx Saga",
         "desc": "Based on the animated series Winx Club, this show is a magical journey following fairies who attend a magical boarding school. You can visit the set of the school in Ireland - a stunning 17th century manor called Killruddery House."
      },
      {
         "show": "Fatherhood",
         "desc": "Fatherhood tells the tale of a single father bringing up his daughter after the unexpected death of his wife. Kevin Hart stars as a father overcoming obstacles, forming a strong father-daughter relationship and learning about himself in the process. Boston Common Park is a featured location in the film that you can visit IRL."
      },
      {
         "show": "Firefly Lane",
         "desc": "Firefly Lane is the ultimate ode to female friendship. It follows two women who met as young girls on, you guessed it, Firefly Lane, and documents their relationship over 30 years of good times and bad. You can visit the mall shown in the first episode IRL, too: the CF Pacific Centre in Downtown Vancouver"
      },
      {
         "show": "Fyre",
         "desc": "Telling the story of ‘the greatest party that never happened’, Fyre documents the disastrous festival thrown by founder Billy McFarland and musician Ja Rule from beginning to end. To see exactly where it all took place, you just need to travel to Great Exuma in the bahamas. Please don’t plan a festival there, though."
      },
      {
         "show": "Ginny & Georgia",
         "desc": "Following the lives of a free spirited mother and her two kids, Ginny & Georgia is a comedy drama exploring the familial relationships and dynamics. It’s a heartwarming and funny watch, and you can even visit the fictional Wellsbury Arts Center, filmed in the grand Victoria Hall."
      },
      {
         "show": "GLOW",
         "desc": "Exploring the world of women’s wrestling, GLOW follows the life of Ruth Wilder, a struggling actress, whose chance at fame comes in a glittery and spandex-covered opportunity. What comes next is a story of friendship and glory, all wrapped up in a glowing package."
      },
      {
         "show": "Godless",
         "desc": "This Western drama sees an on-the-run Roy Goode seek refuge in an isolated town governed mainly by women. The production of Godless was based in Santa Fe Studios, which you can visit IRL - and hopefully there won’t be any stand-offs while you’re there."
      },
      {
         "show": "Grace And Frankie",
         "desc": "This eccentric comedy follows two women who discover their husbands have fallen in love with each other, and develop a firm friendship as a result (after the initial shock has set in, of course). The sitcom is now much-loved by fans - and it’s not hard to see why."
      },
      {
         "show": "Halston",
         "desc": "Documenting the life of Halston, one of America’s most famous fashion designers of the 1970s, this series explores the highs and lows of the icon’s life. Ewan McGregor is in the title role, and the series is only five episodes long - that’s a recipe for the perfect binge watch."
      },
      {
         "show": "House of Cards",
         "desc": "This political drama follows fictional secretary of state Frank Underwood as he sets out on a mission to get revenge on the people that betrayed him. You can even visit Frank and Claire Underwood’s ‘house’ at 1609 Park Ave, Baltimore, MD."
      },
      {
         "show": "Lady Dynamite",
         "desc": "This comedy stars Maria Bamford as a fictionalized version of herself reliving events loosely based on her own life. The constant flashbacks and nonlinear narrative help to tell the story of one woman’s mental health struggle, making it a fascinating watch."
      },
      {
         "show": "Lucifer",
         "desc": "Ever wondered what it would be like if the devil himself had any semblance of compassion? Well, wonder no more, as that’s just what Lucifer explores. In the show, Lucifer meets a detective who makes him feel like there might just be some hope for his soul after all."
      },
      {
         "show": "Lupin",
         "desc": "This French mystery thriller is a retelling of a classic French tale. It follows professional thief Assane Diop, inspired by a book about Arsène Lupin given to him by his father. He sets out on a mission to seek revenge on the family of a man who framed his father years ago - it’s one not to miss."
      },
      {
         "show": "Maid",
         "desc": "This heartwarming story follows a single mother becoming a maid to support her daughter, overcome homelessness and finally escape an abusive relationship. Both optimistic and heartbreaking at the same time, this show will really make you feel your feelings."
      },
      {
         "show": "Manifest",
         "desc": "This supernatural drama follows 191 passengers of a plane, all presumed dead after a mysterious disappearance. When they show up years after takeoff, the passengers must return to a world that has moved on without them, and come to terms with some disturbing realities."
      },
      {
         "show": "Midnight Mass",
         "desc": "A supernatural horror miniseries, Midnight Mass documents the strange events experienced by an isolated community on Crockett Island after the arrival of a mysterious priest. It’s a rollercoaster of a watch."
      },
      {
         "show": "Mindhunter",
         "desc": "In the late 1970s, two FBI agents are tasked with delving into the psychology behind murderers’ actions and pioneering modern serial-killer profiling. This show follows their journey, meeting real life killers and solving a murder in the process."
      },
      {
         "show": "Money Heist",
         "desc": "This Spanish show documents the thrilling fictional heist attempted by a criminal mastermind and a group of criminals with nothing to lose. It’s set to be the biggest heist in history, stealing billions from the Royal Mint of Spain - but will they succeed?"
      },
      {
         "show": "Narcos",
         "desc": "This drama documents the true story of Colombia’s most notorious drug kingpins. Showing the rise of the cocaine trade, the real life stories of the people behind it and the violent events that took place as a result, this show is one not to be missed."
      },
      {
         "show": "Never Have I Ever",
         "desc": "This show follows the life of Devi, a first generation Indian-American teenager, navigating through high school life. With problems caused by friends, family and romantic interests, Never Have I Ever is a fresh take on the classic coming-of-age story."
      },
      {
         "show": "Outer Banks",
         "desc": "Outer Banks is an adventure story like no other. The show follows a teenager and his best friends as they embark on a journey to hunt for treasure - and for the story behind his father’s disappearance."
      },
      {
         "show": "Ozark",
         "desc": "This crime drama follows a financial planner as he relocated his family to the Ozarks after being involved in a money laundering scheme gone wrong. While the family attempts to hide away from what he has done, they are forced to repair their fractured relationships."
      },
      {
         "show": "Queer Eye",
         "desc": "Five experts. Tear-jerking moments. Lives changed all over the country. Queer Eye is the ultimate heartwarming reality show. You can visit many of the places visited in the show, including El Arroyo, owned by someone featured in the most recent series."
      },
      {
         "show": "Raising Dion",
         "desc": "This science fiction show follows the struggles of a single mother bringing up her young son - but here’s the twist, he has superpowers. Not only this, but she must protect him from exploitation while also discovering where the powers came from, and investigating the mysterious circumstances behind her husband’s death."
      },
      {
         "show": "Ratched",
         "desc": "This show follows a young nurse in her descent into darkness. Ratched tells the origin story of the cruel nurse in the now iconic One Flew Over the Cuckoo’s Nest. To visit somewhere featured on the show, go to Toro Place Cafe on the Monterey Salinas Highway - it’s where Nurse Ratched stops on her way to the asylum."
      },
      {
         "show": "Riverdale",
         "desc": "This teen drama is based on the original Archie Comics, but it doesn’t exactly stick to the script. There are twists and turns in every episode, making it a rollercoaster to watch. Want your own experience of the characters’ favorite place, Pop’s Chock’lit Shoppe? Pay a visit to Rocko’s Family Diner in British Columbia - it’s where the pilot scenes were filmed."
      },
      {
         "show": "Russian Doll",
         "desc": "Russian Doll is a mind-bending comedy, starring Natasha Lyonne as a woman caught in a mysterious time loop. The show follows her trying to find her way out of this strange phenomenon, but will she ever escape it?"
      },
      {
         "show": "Schitt’s Creek",
         "desc": "This comedy follows the Rose family as they are forced to leave their lavish lifestyle to live in the only thing they have left in their ownership: the town of Schitt’s Creek. You may not be able to visit the fictional town itself, but you can see the place that transforms into Herb Ertlinger’s winery: Applewood Farm Winery in Toronto."
      },
      {
         "show": "Seinfeld",
         "desc": "The now cult-classic sitcom Seinfeld stars the show’s creator, Jerry Seinfeld, as a fictionalized version of himself living his life with his friends. It’s set mostly in Seinfeld’s apartment, and has been described as a “show about nothing”, but it still remains one of the most loved American comedies. It must be doing something right."
      },
      {
         "show": "Selena: The Series",
         "desc": "This drama documents the real life of the iconic Mexican-American popstar, Selena Quintanilla, as well as her tragic death. For fans of Selena, this show will teach you even more about her life and circumstances. For those that have never heard of her, it will enrich your life with the story of an incredible talent."
      },
      {
         "show": "Sex Education",
         "desc": "Sex Education follows the life of students in a British high school, from Otis, the son of a sex therapist, to Maeve, a rebellious but incredibly intelligent girl. Despite being set in an English school, the show was filmed in Wales. You can visit the stunning area shown on screen by heading to the Wye Valley, and see the impressive school by visiting the Caerleon Campus of the University of South Wales."
      },
      {
         "show": "Shadow And Bone",
         "desc": "This fantasy series follows the events that take place after a young soldier reveals a magical power, and dark forces begin to plot against her. The closest you’ll get to visiting the magical place the show is set in is by going to the ancient Castle Quarter of Budapest."
      },
      {
         "show": "Squid Game",
         "desc": "This hit series revolves around a deadly contest, in which 456 players in deep financial trouble have the chance to win millions - and all they have to do is survive. Exterior shots of the eerie island are of Seongapdo Island in South Korea, but it is not accessible to the public. You can, however, visit the city of Incheon, where protagonist Seong Gi-Hun is from."
      },
      {
         "show": "Stranger Things",
         "desc": "Stranger Things follows a group of teenagers in the 80s who witness some extraordinary events in their small town. From supernatural beings and parallel dimensions to hidden government exploits, the children get deeper into these secrets than they ever thought they’d go."
      },
      {
         "show": "Sweet Tooth",
         "desc": "Gus, a half-human, half-deer boy, goes on an adventure in this show, searching for a new start in a post-apocalyptic world. Hybrids like Gus were created mysteriously after a viral pandemic wiped out the population, so it’s up to the people left to find out where they’ve come from."
      },
      {
         "show": "The Crown",
         "desc": "The Crown is a dramatized version of the events that took place as Queen Elizabeth II took up the throne, and has continued for four seasons so far. Want to see one of the real life places shown in the series? Belvoir Castle in Leicestershire, England stands in for Windsor Castle in the show, and is a stunning place to visit."
      },
      {
         "show": "The Duchess",
         "desc": "This drama film is based on the biography of a late 18th century Duchess, Georgiana Cavendish. Following the life of the young girl after her marriage to the Duke of Devonshire, The Duchess is set in the stunning Kedleston Hall - which you can visit IRL in Derbyshire, England."
      },
      {
         "show": "The Eddy",
         "desc": "This unique drama is set around the owner of a jazz club in Paris, who finds himself tangled up in the activities of criminals. Alongside these troubles, he must fight to protect his club, his players and his young daughter."
      },
      {
         "show": "The Good Place",
         "desc": "Eleanor, a morally questionable person, dies, and finds herself in a heavenly afterlife called ‘the good place’. The problem? They’ve confused her with someone else: someone who’s actually a good person."
      },
      {
         "show": "The Haunting of Bly Manor",
         "desc": "These gothic horror dramas are part of the same anthology, but both stand alone in setting and plot. Both though, as the names would suggest, follow someone who starts to notice some eerie things happening in a grand house. Spooky."
      },
      {
         "show": "The Irishman",
         "desc": "Scorsese’s 3 ½ hour long crime drama has already gained an incredible reputation. It follows a truck driver who becomes involved with a mobster and his crime family after becoming a hitman - and it won ten nominations at the 92nd Academy Awards, so it’s definitely worth a watch."
      },
      {
         "show": "The Last Dance",
         "desc": "This docuseries is one for the sports fans, following Michael Jordan and the Chicago Bulls on their mission to win their sixth NBA title in eight seasons. Jordan is the true main character of the series, with his career shown from high school all the way to the present day. Visit the United Center in Chicago to see the stadium in which they attempted this feat."
      },
      {
         "show": "The One",
         "desc": "This futuristic show is based around a brand new company that can pair people with their soulmate based entirely on their DNA samples. It’s a fascinating premise, leading to many unique obstacles for the characters the show follows."
      },
      {
         "show": "The Queen’s Gambit",
         "desc": "While the idea of watching a young woman play chess for seven hour-long episodes might not sound too gripping, that assumption couldn’t be more wrong. The show deals with many issues, from addiction to success as a woman in the 60s. A few of the chess matches are set in the real life Bode Museum in Berlin, if you want to see where it all (fictionally) went down."
      },
      {
         "show": "The Social Dilemma",
         "desc": "This documentary sees various tech experts from the biggest companies in the world explaining the dangers of social media, from the emotional and behavioral impacts to the purposefully addictive nature of the platforms."
      },
      {
         "show": "The Sons of Sam: A Descent Into Darkness",
         "desc": "This docuseries profiles journalist Maury Terry, a man who spent 40 years of his life trying to prove that the infamous ‘Son of Sam’, A.K.A. David Berkowitz, didn’t act alone while on his killing spree."
      },
      {
         "show": "The Umbrella Academy",
         "desc": "This show revolves around a dysfunctional family of adopted superheroes, all mysteriously born on the same day at the same time, adopted by an eccentric billionaire and trained to save the world. With time jumps and complex relationships, it’s a really great watch."
      },
      {
         "show": "The White Tiger",
         "desc": "When a young man from a poor Indian village gets a job as a driver for a rich family, he begins to use his wit and cunning to turn his situation around and escape from poverty. With an aim to reach the very top of the social ladder, will he succeed?"
      },
      {
         "show": "Tiger King: Murder, Mayhem And Madness",
         "desc": "Focusing on the strange life of Joe Exotic, this documentary takes so many turns that you would never see coming. Starting off simply as the story of an exotic animal owner, by the end of the series you’ll be wondering what just happened - in a good way. Visit Carole Baskin at Big Cat Rescue for an extra taste of the madness."
      },
      {
         "show": "Unbelievable",
         "desc": "Based on a true story, this show follows a young woman who has reported being raped, leading to two female detectives discovering a series of very similar attacks. It’s gritty and hard to watch, but the important subject matter is something that should be seen by everyone."
      },
      {
         "show": "Unbreakable Kimmy Schmidt",
         "desc": "When a woman is rescued from a cult 15 years after being kidnapped, she must readjust herself to bustling New York City with the unlikely group of friends she meets along the way. Both hilarious and heartwarming, this is the perfect weekend binge watch."
      },
      {
         "show": "Vincenzo",
         "desc": "Fans of this South Korean mafia drama should visit the Geumga Plaza, where many of the scenes were filmed. The show follows a Korean-Italian mob lawyer unwittingly becoming a warrior of justice despite his close ties to one of the biggest crime families in the world."
      },
      {
         "show": "When They See Us",
         "desc": "This extremely hard-hitting show tells the story of the five young boys who were falsely accused of attacking and raping a woman in Central Park. This series spans a long period of time, from 1989 to 2014, showing just how long the five endured this nightmare."
      },
      {
         "show": "You",
         "desc": "This hit series follows Joe Goldberg, a self-proclaimed ‘romantic’, as he becomes obsessed with a woman he meets in a bookstore. He uses every tool at his disposal, from social media to plain old stalking, to get as close to her as possible - even getting rid of people in the process."
      },
      {
         "show": "The Lost Daughter",
         "desc": "This psychological drama follows a woman confronting her past when she becomes obsessed with a woman and her daughter on holiday, bringing up old memories and sending her on an intense emotional journey. "
      },
      {
         "show": "The Dig",
         "desc": "A historical drama, The Dig is set on the eve of World War II. As a woman hires an archaeologist to dig up mysterious formations on her land, the two find much more than they bargained for in this emotional piece."
      },
      {
         "show": "tick…tick…BOOM!",
         "desc": "The multi-award-winning Tick, Tick... Boom! follows a young pianist as he works to make his musical career a success. He discovers how great passions require great sacrifices, as his dedication to his craft costs him friendships and relationships. It's a real emotional ride, packed full of songs you'll be humming for days."

      }
   ]
}